/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberReturn = {
  __typename?: 'AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberReturn';
  agreementAcceptedSuccessfully: Scalars['Boolean']['output'];
};

export type AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberReturn = {
  __typename?: 'AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberReturn';
  agreementAcceptedSuccessfully: Scalars['Boolean']['output'];
};

export type AcceptPerksLinkRequestReturn = {
  __typename?: 'AcceptPerksLinkRequestReturn';
  perksLinkAcceptedSuccessfully: Scalars['Boolean']['output'];
};

export type ActivateBannerForCategoryAdvertisingBannerReturn = {
  __typename?: 'ActivateBannerForCategoryAdvertisingBannerReturn';
  bannerActivatedSuccessfully: Scalars['Boolean']['output'];
};

export type ActivateMemberProfileAndPerksBannersForChamberMemberReturn = {
  __typename?: 'ActivateMemberProfileAndPerksBannersForChamberMemberReturn';
  activationSuccessful: Scalars['Boolean']['output'];
};

export type ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn = {
  __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn';
  chamberMemberHasAcceptedAgreement: Scalars['Boolean']['output'];
  memberProfileAndPerkBannerActivationFeeInDollarsAtTimeOfActivation: Scalars['Float']['output'];
  memberProfileAndPerkBannerAnnualBannerFeeInDollarsAtTimeOfActivation: Scalars['Float']['output'];
  sentEmailNotificationOfUpcomingExpiry: Scalars['Boolean']['output'];
  startDateUtcMilli: Scalars['Float']['output'];
};

export type ActiveMemberProfileAndPerksBannersSettingsReturn = {
  __typename?: 'ActiveMemberProfileAndPerksBannersSettingsReturn';
  activationInfo: ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn;
  reactivationInfo?: Maybe<ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  province: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type AddressReturn = {
  __typename?: 'AddressReturn';
  city: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  province: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
};

export type AdminConsoleLoginEmailReturn = {
  __typename?: 'AdminConsoleLoginEmailReturn';
  adminConsoleLoginEmail: Scalars['String']['output'];
};

export type AllCategoryAdvertisingBannersForChamberReturn = {
  __typename?: 'AllCategoryAdvertisingBannersForChamberReturn';
  categoryAdvertisingBanners: Array<CategoryAdvertisingBannerReturn>;
  chamberId: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
};

export enum BannerContentTypeEnum {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type BannerInput = {
  contentType: BannerContentTypeEnum;
  contentUrl: Scalars['String']['input'];
  imageLink?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Float']['input'];
  waitingForApprovalByChamberAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BannerReturn = {
  __typename?: 'BannerReturn';
  contentType: BannerContentTypeEnum;
  contentUrl: Scalars['String']['output'];
  imageLink?: Maybe<Scalars['String']['output']>;
  position: Scalars['Float']['output'];
  waitingForApprovalByChamberAdmin?: Maybe<Scalars['Boolean']['output']>;
};

export type CpaSignUpChambersForCityReturn = {
  __typename?: 'CPASignUpChambersForCityReturn';
  multipleChambersInCity?: Maybe<SignUpMultipleMatchingChambersReturn>;
  noChambersInCity_closestChambersToCity?: Maybe<SignUpNoMatchingChambersReturn>;
  singleChamberInCity?: Maybe<SignUpSingleMatchingChamberReturn>;
};

export type CapUserAgreedToRewardCampaignMutationReturn = {
  __typename?: 'CapUserAgreedToRewardCampaignMutationReturn';
  capUserAgreedSuccessfully: Scalars['Boolean']['output'];
};

export type CapUserAgreedToRewardCampaignReturn = {
  __typename?: 'CapUserAgreedToRewardCampaignReturn';
  capUserId: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  rewardCampaignId: Scalars['String']['output'];
};

export type CapUserPerkPartnerDiscountReturn = {
  __typename?: 'CapUserPerkPartnerDiscountReturn';
  ineligiblePerkPartnerDiscountsForCurrentlyLoggedInCapUser?: Maybe<Array<IneligiblePerkPartnerDiscountReturn>>;
  unverified_eligiblePerkPartnerDiscountsForCurrentlyLoggedInCapUser?: Maybe<Array<PerkPartnerDiscountReturn>>;
  verified_eligiblePerkPartnerDiscountsForCurrentlyLoggedInCapUser?: Maybe<Array<PerkPartnerDiscountReturn>>;
};

export type CapUserShareLeadingToOpenRecordInput = {
  capUniqueInstallationIdForLoggedOutCapUserTracking?: InputMaybe<Scalars['String']['input']>;
  onlyTrackingAppOpenAndNotSharedItemOpen?: InputMaybe<Scalars['Boolean']['input']>;
  shareType: CapUserShareLeadingToOpenRecordShareTypeEnum;
  sharedItemId: Scalars['String']['input'];
  sharedItemOwnedByChamberId: Scalars['String']['input'];
  shareeIsBrandNewUser: Scalars['Boolean']['input'];
  sharerChamberIdWhenShareExecuted: Scalars['String']['input'];
  sharerUserId: Scalars['String']['input'];
};

export type CapUserShareLeadingToOpenRecordReturn = {
  __typename?: 'CapUserShareLeadingToOpenRecordReturn';
  capUniqueInstallationIdForLoggedOutCapUserTracking?: Maybe<Scalars['String']['output']>;
  createdAtUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  onlyTrackingAppOpenAndNotSharedItemOpen?: Maybe<Scalars['Boolean']['output']>;
  shareType: CapUserShareLeadingToOpenRecordShareTypeEnum;
  sharedItemId: Scalars['String']['output'];
  sharedItemOwnedByChamberId: Scalars['String']['output'];
  shareeChamberIdWhenShareOpened: Scalars['String']['output'];
  shareeIsBrandNewUser: Scalars['Boolean']['output'];
  shareeUserId: Scalars['String']['output'];
  sharerChamberIdWhenShareExecuted: Scalars['String']['output'];
  sharerUserId: Scalars['String']['output'];
};

export enum CapUserShareLeadingToOpenRecordShareTypeEnum {
  ChamberMember = 'CHAMBER_MEMBER',
  Discount = 'DISCOUNT'
}

export type CapUserShareRecordReturn = {
  __typename?: 'CapUserShareRecordReturn';
  createdAtUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  shareType: InAppShareTypes;
  sharedItemId: Scalars['String']['output'];
  sharedItemOwnedByChamberId: Scalars['String']['output'];
  sharerChamberIdWhenShareExecuted: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CapUserViewedRewardCampaignMutationReturn = {
  __typename?: 'CapUserViewedRewardCampaignMutationReturn';
  capUserViewedSuccessfully: Scalars['Boolean']['output'];
};

export type CapUserViewedRewardCampaignReturn = {
  __typename?: 'CapUserViewedRewardCampaignReturn';
  capUserId: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  rewardCampaignId: Scalars['String']['output'];
};

export type CategoryAdvertisingBannerActivationInfoInput = {
  activationStartDateUtcMilli: Scalars['Float']['input'];
  autoApproveBannerContentUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  bannerFeeOptionSetAtActivationTime: CategoryAdvertisingBannersFeeOptionsInput;
  chamberMemberId: Scalars['String']['input'];
};

export type CategoryAdvertisingBannerActivationInfoReturn = {
  __typename?: 'CategoryAdvertisingBannerActivationInfoReturn';
  activationStartDateUtcMilli: Scalars['Float']['output'];
  autoApproveBannerContentUpdate?: Maybe<Scalars['Boolean']['output']>;
  banner?: Maybe<Array<BannerReturn>>;
  bannerFeeOptionSetAtActivationTime: CategoryAdvertisingBannersFeeOptionsReturn;
  categoryAdvertisingBannersActivationFeeCpaSplitPercentageSetAtActivationTime: Scalars['Float']['output'];
  chamberMemberHasAcceptedAgreement: Scalars['Boolean']['output'];
  chamberMemberId: Scalars['String']['output'];
  sentEmailNotificationOfUpcomingExpiry: Scalars['Boolean']['output'];
};

export type CategoryAdvertisingBannerReactivationInfoInput = {
  autoApproveBannerContentUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  bannerFeeOptionSetAtActivationTime: CategoryAdvertisingBannersFeeOptionsInput;
  chamberMemberId: Scalars['String']['input'];
};

export type CategoryAdvertisingBannerReturn = {
  __typename?: 'CategoryAdvertisingBannerReturn';
  bannerSettings?: Maybe<CategoryAdvertisingBannerSettingsReturn>;
  categoryId: ChamberMemberCategory;
};

export type CategoryAdvertisingBannerSettingsReturn = {
  __typename?: 'CategoryAdvertisingBannerSettingsReturn';
  activationInfo: CategoryAdvertisingBannerActivationInfoReturn;
  reactivationInfo?: Maybe<CategoryAdvertisingBannerActivationInfoReturn>;
};

export enum CategoryAdvertisingBannerUpdateRecordEventEnum {
  Activation = 'ACTIVATION',
  ChamberMemberAgreementAcceptance = 'CHAMBER_MEMBER_AGREEMENT_ACCEPTANCE',
  ContentUpdate = 'CONTENT_UPDATE',
  ContentUpdateAutoApprovalChange = 'CONTENT_UPDATE_AUTO_APPROVAL_CHANGE',
  Expiration = 'EXPIRATION',
  Reactivation = 'REACTIVATION'
}

export type CategoryAdvertisingBannerUpdateRecordReturn = {
  __typename?: 'CategoryAdvertisingBannerUpdateRecordReturn';
  activationDateUtcMilli: Scalars['Float']['output'];
  bannerAtEventTrigger: CategoryAdvertisingBannerSettingsReturn;
  categoryId: ChamberMemberCategory;
  chamberId: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  excludeFromInvoice?: Maybe<Scalars['Boolean']['output']>;
  expirationDateUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  invoiceSentAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  recordEvent: CategoryAdvertisingBannerUpdateRecordEventEnum;
  triggeringUserId: Scalars['String']['output'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
};

export type CategoryAdvertisingBannersFeeOptionsInput = {
  bannerFeeInDollars: Scalars['Float']['input'];
  timeLengthInMonths: Scalars['Float']['input'];
};

export type CategoryAdvertisingBannersFeeOptionsReturn = {
  __typename?: 'CategoryAdvertisingBannersFeeOptionsReturn';
  bannerFeeInDollars: Scalars['Float']['output'];
  timeLengthInMonths: Scalars['Float']['output'];
};

export type CategoryReturn = {
  __typename?: 'CategoryReturn';
  id: ChamberMemberCategory;
  name: Scalars['String']['output'];
};

export type ChamberAdminUserReturn = {
  __typename?: 'ChamberAdminUserReturn';
  chamberAddedSuccessfully: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
};

export type ChamberEngageActivationFeeRevenueReturn = {
  __typename?: 'ChamberEngageActivationFeeRevenueReturn';
  activationFeeRevenue: Scalars['Float']['output'];
  categoryAdvertisingActivationFeeRevenue: Scalars['Float']['output'];
  chamberCategoryAdvertisingRevenue: Scalars['Float']['output'];
  chamberFeaturedMemberRevenue: Scalars['Float']['output'];
  chamberRevenue: Scalars['Float']['output'];
  featuredMemberActivationFeeRevenue: Scalars['Float']['output'];
};

export type ChamberEngageActivationToMarkInvoicedInput = {
  activationId: Scalars['String']['input'];
  activationType: ChamberEngageActivationTypeEnum;
  invoiceSentAtUtcMilli?: InputMaybe<Scalars['Float']['input']>;
};

export enum ChamberEngageActivationTypeEnum {
  CategoryAdvertising = 'CATEGORY_ADVERTISING',
  MemberProfileAndPerksBanners = 'MEMBER_PROFILE_AND_PERKS_BANNERS'
}

export type ChamberEngageMonthlyInvoiceChamberDataReturn = {
  __typename?: 'ChamberEngageMonthlyInvoiceChamberDataReturn';
  activations?: Maybe<Array<ChamberEngageMonthlyInvoiceIndividualActivationDataReturn>>;
  allInvoicesSentForChamberInMonth: Scalars['Boolean']['output'];
  categoryAdvertisingActivated: Scalars['Float']['output'];
  categoryAdvertisingChamberRevenueInDollars: Scalars['Float']['output'];
  categoryAdvertisingTotalActivationFeeInDollars: Scalars['Float']['output'];
  chamberId: Scalars['String']['output'];
  chamberName: Scalars['String']['output'];
  memberProfileAndPerksBannersActivated: Scalars['Float']['output'];
  memberProfileAndPerksBannersChamberRevenueInDollars: Scalars['Float']['output'];
  memberProfileAndPerksBannersTotalActivationFeeInDollars: Scalars['Float']['output'];
  totalActivationFeeInDollars: Scalars['Float']['output'];
  totalChamberRevenueInDollars: Scalars['Float']['output'];
};

export type ChamberEngageMonthlyInvoiceDataReturn = {
  __typename?: 'ChamberEngageMonthlyInvoiceDataReturn';
  allInvoicesSentInMonth: Scalars['Boolean']['output'];
  chamberData?: Maybe<Array<ChamberEngageMonthlyInvoiceChamberDataReturn>>;
  monthNum: Scalars['Float']['output'];
  totalActivationFeeInDollars: Scalars['Float']['output'];
  totalCategoryAdvertisingActivationFeeInDollars: Scalars['Float']['output'];
  totalCategoryAdvertisingChamberRevenueInDollars: Scalars['Float']['output'];
  totalChamberRevenueInDollars: Scalars['Float']['output'];
  totalMemberProfileAndPerksBannersActivationFeeInDollars: Scalars['Float']['output'];
  totalMemberProfileAndPerksBannersChamberRevenueInDollars: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export type ChamberEngageMonthlyInvoiceIndividualActivationDataReturn = {
  __typename?: 'ChamberEngageMonthlyInvoiceIndividualActivationDataReturn';
  activationFeeInDollars: Scalars['Float']['output'];
  activationId: Scalars['String']['output'];
  activationLengthInMonths: Scalars['Float']['output'];
  activationType: ChamberEngageActivationTypeEnum;
  categoryAdvertisingCategoryId?: Maybe<ChamberMemberCategory>;
  chamberMemberId: Scalars['String']['output'];
  chamberMemberName: Scalars['String']['output'];
  chamberRevenueInDollars: Scalars['Float']['output'];
  includeInInvoice: Scalars['Boolean']['output'];
  invoiceSentAtUtcMilli?: Maybe<Scalars['Float']['output']>;
};

export type ChamberEngageSettingsInput = {
  categoryAdvertisingBannersActivationFeeCpaSplitPercentage: Scalars['Float']['input'];
  categoryAdvertisingBannersFeeOptions: Array<CategoryAdvertisingBannersFeeOptionsInput>;
  isActive: Scalars['Boolean']['input'];
  memberProfileAndPerkBannerActivationFeeInDollars: Scalars['Float']['input'];
  memberProfileAndPerkBannerAnnualBannerFeeInDollars: Scalars['Float']['input'];
};

export type ChamberEngageSettingsReturn = {
  __typename?: 'ChamberEngageSettingsReturn';
  activationTimeUtcMilli?: Maybe<Scalars['Float']['output']>;
  categoryAdvertisingBannersActivationFeeCpaSplitPercentage: Scalars['Float']['output'];
  categoryAdvertisingBannersFeeOptions: Array<CategoryAdvertisingBannersFeeOptionsReturn>;
  isActive: Scalars['Boolean']['output'];
  memberProfileAndPerkBannerActivationFeeInDollars: Scalars['Float']['output'];
  memberProfileAndPerkBannerAnnualBannerFeeInDollars: Scalars['Float']['output'];
};

export type ChamberInput = {
  address: AddressInput;
  adminConsoleLoginEmail?: InputMaybe<Scalars['String']['input']>;
  advocacyWinsLink?: InputMaybe<Scalars['String']['input']>;
  advocacyWinsLinkShowRedBubbleNotificationForLoggedInCapUser?: InputMaybe<Scalars['Boolean']['input']>;
  advocacyWinsLinkUpdatedAtUtcMilli?: InputMaybe<Scalars['Float']['input']>;
  chamberMemberProWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  directoryBanner?: InputMaybe<Array<BannerInput>>;
  eventsLink?: InputMaybe<Scalars['String']['input']>;
  eventsLinkShowRedBubbleNotificationForLoggedInCapUser?: InputMaybe<Scalars['Boolean']['input']>;
  eventsLinkUpdatedAtUtcMilli?: InputMaybe<Scalars['Float']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  hideInApp?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  instagram?: InputMaybe<Scalars['String']['input']>;
  isSandbox?: InputMaybe<Scalars['Boolean']['input']>;
  jobPostingLink?: InputMaybe<Scalars['String']['input']>;
  jobPostingLinkShowRedBubbleNotificationForLoggedInCapUser?: InputMaybe<Scalars['Boolean']['input']>;
  jobPostingLinkUpdatedAtUtcMilli?: InputMaybe<Scalars['Float']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  memberSignupLink?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  newsletterLink?: InputMaybe<Scalars['String']['input']>;
  newsletterLinkShowRedBubbleNotificationForLoggedInCapUser?: InputMaybe<Scalars['Boolean']['input']>;
  newsletterLinkUpdatedAtUtcMilli?: InputMaybe<Scalars['Float']['input']>;
  numberOfMembersFromInitialSubscriptionAgreement?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  premiumChamberMarketerLink?: InputMaybe<Scalars['String']['input']>;
  profileBanner?: InputMaybe<Array<BannerInput>>;
  purchasedItems?: InputMaybe<Array<ItemsPurchasableByChamberEnum>>;
  sponsorLogo?: InputMaybe<Scalars['String']['input']>;
  sponsorLogoLink?: InputMaybe<Scalars['String']['input']>;
  subscriptionDate?: InputMaybe<Scalars['String']['input']>;
  subscriptionPlanType?: InputMaybe<ChamberPerksAppSubscriptionPlanTypesEnum>;
  supportContactEmail: Scalars['String']['input'];
  supportContactName?: InputMaybe<Scalars['String']['input']>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  surveyLink?: InputMaybe<Scalars['String']['input']>;
  surveyLinkShowRedBubbleNotificationForLoggedInCapUser?: InputMaybe<Scalars['Boolean']['input']>;
  surveyLinkUpdatedAtUtcMilli?: InputMaybe<Scalars['Float']['input']>;
  threads?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website: Scalars['String']['input'];
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export enum ChamberMemberCategory {
  AccommodationsAttractions = 'ACCOMMODATIONS_ATTRACTIONS',
  AutomotiveTransportation = 'AUTOMOTIVE_TRANSPORTATION',
  CommunicationTechnology = 'COMMUNICATION_TECHNOLOGY',
  ConstructionIndustrial = 'CONSTRUCTION_INDUSTRIAL',
  ConstructionSuppliers = 'CONSTRUCTION_SUPPLIERS',
  FarmingAgriculture = 'FARMING_AGRICULTURE',
  Financial = 'FINANCIAL',
  GovernmentEducation = 'GOVERNMENT_EDUCATION',
  HealthSafety = 'HEALTH_SAFETY',
  Industries = 'INDUSTRIES',
  MarketingAdvertising = 'MARKETING_ADVERTISING',
  NonProfit = 'NON_PROFIT',
  PersonalServices = 'PERSONAL_SERVICES',
  ProfessionalServices = 'PROFESSIONAL_SERVICES',
  RealEstate = 'REAL_ESTATE',
  Restaurant = 'RESTAURANT',
  Retail = 'RETAIL',
  SportsRecreation = 'SPORTS_RECREATION'
}

export type ChamberMemberInput = {
  address: AddressInput;
  adminConsoleContactName?: InputMaybe<Scalars['String']['input']>;
  adminConsoleLoginEmail?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Array<BannerInput>>;
  categoryId: Array<ChamberMemberCategory>;
  chamberId: Scalars['String']['input'];
  contactName?: InputMaybe<Scalars['String']['input']>;
  customContacts?: InputMaybe<Array<CustomContactInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  facebook?: InputMaybe<Scalars['String']['input']>;
  hasSignedUp?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  instagram?: InputMaybe<Scalars['String']['input']>;
  isSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  showInApp: Scalars['Boolean']['input'];
  threads?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export enum ChamberMemberProPagePermissionsEnum {
  ChamberAdminEmailAnalytics = 'CHAMBER_ADMIN__EMAIL__ANALYTICS',
  ChamberAdminEmailCreateEmail = 'CHAMBER_ADMIN__EMAIL__CREATE_EMAIL',
  ChamberAdminEmailManageEmails = 'CHAMBER_ADMIN__EMAIL__MANAGE_EMAILS',
  ChamberAdminEventsAnalytics = 'CHAMBER_ADMIN__EVENTS__ANALYTICS',
  ChamberAdminEventsCreateEvent = 'CHAMBER_ADMIN__EVENTS__CREATE_EVENT',
  ChamberAdminEventsManageEvent = 'CHAMBER_ADMIN__EVENTS__MANAGE_EVENT',
  ChamberAdminInvoicingAnalytics = 'CHAMBER_ADMIN__INVOICING__ANALYTICS',
  ChamberAdminInvoicingManageInvoices = 'CHAMBER_ADMIN__INVOICING__MANAGE_INVOICES',
  ChamberAdminMembersAnalytics = 'CHAMBER_ADMIN__MEMBERS__ANALYTICS',
  ChamberAdminMembersCreateMember = 'CHAMBER_ADMIN__MEMBERS__CREATE_MEMBER',
  ChamberAdminMembersManageMember = 'CHAMBER_ADMIN__MEMBERS__MANAGE_MEMBER',
  ChamberAdminMembersMembershipSettings = 'CHAMBER_ADMIN__MEMBERS__MEMBERSHIP_SETTINGS',
  ChamberAdminMyChamberAnalytics = 'CHAMBER_ADMIN__MY_CHAMBER__ANALYTICS',
  ChamberAdminMyChamberManageChamberProfile = 'CHAMBER_ADMIN__MY_CHAMBER__MANAGE_CHAMBER_PROFILE',
  ChamberAdminMyChamberManageChamberTeam = 'CHAMBER_ADMIN__MY_CHAMBER__MANAGE_CHAMBER_TEAM',
  ChamberAdminReports = 'CHAMBER_ADMIN__REPORTS',
  ChamberAdminSettingsMyProfile = 'CHAMBER_ADMIN__SETTINGS__MY_PROFILE',
  ChamberAdminSettingsResetPassword = 'CHAMBER_ADMIN__SETTINGS__RESET_PASSWORD',
  ChamberAdminSupport = 'CHAMBER_ADMIN__SUPPORT',
  ChamberAdminWebsiteAnalytics = 'CHAMBER_ADMIN__WEBSITE__ANALYTICS',
  ChamberAdminWebsiteManageWebsite = 'CHAMBER_ADMIN__WEBSITE__MANAGE_WEBSITE'
}

export type ChamberMemberProPermissionsNeededInput = {
  anyEnabledPermissionNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  chamberAdmin_EnabledPagesNeeded?: InputMaybe<Array<ChamberMemberProPagePermissionsEnum>>;
};

export type ChamberMemberReturn = {
  __typename?: 'ChamberMemberReturn';
  activeMemberProfileAndPerksBannersSettings?: Maybe<ActiveMemberProfileAndPerksBannersSettingsReturn>;
  address: AddressReturn;
  adminConsoleContactName?: Maybe<Scalars['String']['output']>;
  adminConsoleLoginEmail?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Array<BannerReturn>>;
  categoryId: Array<ChamberMemberCategory>;
  chamberId: Scalars['String']['output'];
  contactName?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<CoordinateReturn>;
  createdAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  credentialsSentAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  credentialsSentAtUtcMilliBeforeSigningUp?: Maybe<Scalars['Float']['output']>;
  currentLoggedInCapUserHasFavorited?: Maybe<Scalars['Boolean']['output']>;
  customContacts?: Maybe<Array<CustomContactReturn>>;
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  facebook?: Maybe<Scalars['String']['output']>;
  hasSignedUp?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  isChambersRootMember?: Maybe<Scalars['Boolean']['output']>;
  isSuspended?: Maybe<Scalars['Boolean']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfFavorites?: Maybe<Scalars['Float']['output']>;
  numberOfUsers?: Maybe<Scalars['Float']['output']>;
  phoneNumber: Scalars['String']['output'];
  showInApp: Scalars['Boolean']['output'];
  showRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']['output']>;
  threads?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type ChamberMemberUserReturn = {
  __typename?: 'ChamberMemberUserReturn';
  chamberMemberAddedSuccessfully: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
};

export enum ChamberPerksAppSubscriptionPlanTypesEnum {
  Standard = 'STANDARD',
  Starter = 'STARTER'
}

export type ChamberReturn = {
  __typename?: 'ChamberReturn';
  address: AddressReturn;
  advocacyWinsLink?: Maybe<Scalars['String']['output']>;
  advocacyWinsLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']['output']>;
  advocacyWinsLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  allMemberLoginCredentialSuccessfulDownloadTimestampUtcMilli?: Maybe<Scalars['Float']['output']>;
  allMemberMassSendLoginCredentialTimestampUtcMilli?: Maybe<Scalars['Float']['output']>;
  chamberEngageSettings: ChamberEngageSettingsReturn;
  chamberMemberProWebsiteUrl?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<CoordinateReturn>;
  createdAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directoryBanner?: Maybe<Array<BannerReturn>>;
  eventsLink?: Maybe<Scalars['String']['output']>;
  eventsLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']['output']>;
  eventsLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  googleMapsApi_City_ProvinceShort_CountryShort: Scalars['String']['output'];
  hideInApp?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  isSandbox?: Maybe<Scalars['Boolean']['output']>;
  jobPostingLink?: Maybe<Scalars['String']['output']>;
  jobPostingLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']['output']>;
  jobPostingLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  memberSignupLink?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  newsletterLink?: Maybe<Scalars['String']['output']>;
  newsletterLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']['output']>;
  newsletterLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  numberOfMembersFromInitialSubscriptionAgreement?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  premiumChamberMarketerLink?: Maybe<Scalars['String']['output']>;
  profileBanner?: Maybe<Array<BannerReturn>>;
  purchasedItems?: Maybe<Array<ItemsPurchasableByChamberEnum>>;
  sponsorLogo?: Maybe<Scalars['String']['output']>;
  sponsorLogoLink?: Maybe<Scalars['String']['output']>;
  subscriptionDate?: Maybe<Scalars['String']['output']>;
  subscriptionPlanType: ChamberPerksAppSubscriptionPlanTypesEnum;
  supportContactEmail: Scalars['String']['output'];
  supportContactName?: Maybe<Scalars['String']['output']>;
  supportLink?: Maybe<Scalars['String']['output']>;
  surveyLink?: Maybe<Scalars['String']['output']>;
  surveyLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']['output']>;
  surveyLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  threads?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  website: Scalars['String']['output'];
  youtube?: Maybe<Scalars['String']['output']>;
};

export type ChambersStatsReturn = {
  __typename?: 'ChambersStatsReturn';
  discountsPerCategoryBreakdown: Array<DiscountsPerCategoryBreakdownReturn>;
  name: Scalars['String']['output'];
  numberChangeInNumberOfChamberMembersBetweenNowAndInitial: Scalars['Float']['output'];
  numberOfAppUsers: Scalars['Float']['output'];
  numberOfAppUsersSignedUpWithAnEmployer: Scalars['Float']['output'];
  numberOfAppUsersSignedUpWithoutAnEmployer: Scalars['Float']['output'];
  numberOfAppUsersWithNearbyPerkNotificationEnabled: Scalars['Float']['output'];
  numberOfAppUsersWithNewPerkNotificationEnabled: Scalars['Float']['output'];
  numberOfChamberMembersLiveOnApp: Scalars['Float']['output'];
  numberOfChamberMembersLoggedInToAdminPortal: Scalars['Float']['output'];
  numberOfChamberMembersOfferingLiveDiscounts: Scalars['Float']['output'];
  numberOfChamberMembersThatWereEmailedTheirCredentialsBeforeFirstLogin: Scalars['Float']['output'];
  numberOfDiscountRedemptions: Scalars['Float']['output'];
  numberOfDiscountViews: Scalars['Float']['output'];
  numberOfLiveDiscounts: Scalars['Float']['output'];
  numberOfMembersFromInitialSubscriptionAgreement: Scalars['Float']['output'];
  numberOfSuspendedChamberMembers: Scalars['Float']['output'];
  percentageChangeInNumberOfChamberMembersBetweenNowAndInitial: Scalars['Float']['output'];
  percentageOfAppUsersWithNearbyPerkNotificationEnabled: Scalars['Float']['output'];
  percentageOfAppUsersWithNewPerkNotificationEnabled: Scalars['Float']['output'];
  percentageOfChamberMembersLoggedInToAdminPortal: Scalars['Float']['output'];
  percentageOfChamberMembersOfferingLiveDiscounts: Scalars['Float']['output'];
  percentageOfChamberMembersThatWereEmailedTheirCredentialsBeforeFirstLogin: Scalars['Float']['output'];
  subscriptionDate: Scalars['String']['output'];
  subscriptionUTCMilli: Scalars['Float']['output'];
};

export type ChangeAdminConsoleLoginEmailReturn = {
  __typename?: 'ChangeAdminConsoleLoginEmailReturn';
  adminConsoleLoginEmailChangedSuccessfully: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
};

export type ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerReturn = {
  __typename?: 'ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerReturn';
  autoApprovalUpdateSuccessful: Scalars['Boolean']['output'];
};

export type ChangeChamberEventInput = {
  newChamberId: Scalars['String']['input'];
  newChamberName: Scalars['String']['input'];
  previousChamberId: Scalars['String']['input'];
  previousChamberName: Scalars['String']['input'];
};

export enum ClientsThatCanAccessApiEnum {
  ChamberMemberPro = 'CHAMBER_MEMBER_PRO',
  ChamberPerksApp = 'CHAMBER_PERKS_APP',
  ChamberPerksAppAdminConsole = 'CHAMBER_PERKS_APP_ADMIN_CONSOLE'
}

export type ContactableChamberReturn = {
  __typename?: 'ContactableChamberReturn';
  createdAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  createdAtUtcTimestamp?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ContactableCompanyReturn = {
  __typename?: 'ContactableCompanyReturn';
  chamberId: Scalars['String']['output'];
  chamberName: Scalars['String']['output'];
  createdAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  createdAtUtcTimestamp?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CoordinateReturn = {
  __typename?: 'CoordinateReturn';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CreateAllMemberLoginCredentialsReturn = {
  __typename?: 'CreateAllMemberLoginCredentialsReturn';
  processId: Scalars['String']['output'];
};

export type CreateCapUserShareLeadingToOpenRecordMutationReturn = {
  __typename?: 'CreateCapUserShareLeadingToOpenRecordMutationReturn';
  recordCreatedSuccessfully: Scalars['Boolean']['output'];
};

export type CreateChamberContactableCompanyMutationInput = {
  chamberId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateChamberMembersMutationInput = {
  data: Array<ChamberMemberInput>;
};

export type CreateChamberMembersMutationReturn = {
  __typename?: 'CreateChamberMembersMutationReturn';
  results: Array<ChamberMemberUserReturn>;
};

export type CreateChamberMutationInput = {
  data: Array<ChamberInput>;
};

export type CreateChamberMutationReturn = {
  __typename?: 'CreateChamberMutationReturn';
  results: Array<ChamberAdminUserReturn>;
};

export type CreateContactableChamberMutationInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateDiscountsMutationInput = {
  data: Array<DiscountInput>;
};

export type CreateDiscountsMutationReturn = {
  __typename?: 'CreateDiscountsMutationReturn';
  discountsAddedSuccessfully: Scalars['Boolean']['output'];
};

export type CreateFavoritedChamberMemberMutationReturn = {
  __typename?: 'CreateFavoritedChamberMemberMutationReturn';
  favoritedChamberMemberAddedSuccessfully: Scalars['Boolean']['output'];
};

export type CreateFavoritedDiscountMutationReturn = {
  __typename?: 'CreateFavoritedDiscountMutationReturn';
  favoritedDiscountAddedSuccessfully: Scalars['Boolean']['output'];
};

export type CreatePerkPartnerDiscountAdminUserMutationReturn = {
  __typename?: 'CreatePerkPartnerDiscountAdminUserMutationReturn';
  email: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  perkPartnerDiscountAdminUserCreatedSuccessfully: Scalars['Boolean']['output'];
};

export type CreatePerkPartnerDiscountMutationReturn = {
  __typename?: 'CreatePerkPartnerDiscountMutationReturn';
  perkPartnerDiscountAddedSuccessfully: Scalars['Boolean']['output'];
};

export type CreateRedeemedDiscountMutationReturn = {
  __typename?: 'CreateRedeemedDiscountMutationReturn';
  redeemedDiscountAddedSuccessfully: Scalars['Boolean']['output'];
};

export type CreateRedeemedDiscountsMutationInput = {
  data: Array<RedeemedDiscountInput>;
};

export type CreateRedeemedDiscountsMutationReturn = {
  __typename?: 'CreateRedeemedDiscountsMutationReturn';
  redeemedDiscountsAddedSuccessfully: Scalars['Boolean']['output'];
};

export type CreateRewardCampaignMutationReturn = {
  __typename?: 'CreateRewardCampaignMutationReturn';
  campaignCreatedSuccessfully: Scalars['Boolean']['output'];
};

export type CreateShopLocalCampaignPrizeDrawParticipantReturn = {
  __typename?: 'CreateShopLocalCampaignPrizeDrawParticipantReturn';
  shopLocalCampaignPrizeDrawParticipantCreatedSuccessfully: Scalars['Boolean']['output'];
};

export type CreateShopLocalCampaignReturn = {
  __typename?: 'CreateShopLocalCampaignReturn';
  shopLocalCampaignCreatedSuccessfully: Scalars['Boolean']['output'];
};

export type CreateUserMutationInput = {
  data: Array<UserInput>;
};

export type CreateUserMutationReturn = {
  __typename?: 'CreateUserMutationReturn';
  usersAddedSuccessfully: Scalars['Boolean']['output'];
};

export type CustomContactInput = {
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CustomContactReturn = {
  __typename?: 'CustomContactReturn';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export enum DayEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeactivateMemberProfileAndPerksBannersForChamberMemberReturn = {
  __typename?: 'DeactivateMemberProfileAndPerksBannersForChamberMemberReturn';
  deactivationSuccessful: Scalars['Boolean']['output'];
};

export type DeleteFavoritedChamberMemberMutationReturn = {
  __typename?: 'DeleteFavoritedChamberMemberMutationReturn';
  favoritedChamberMemberDeletedSuccessfully: Scalars['Boolean']['output'];
};

export type DeleteFavoritedDiscountMutationReturn = {
  __typename?: 'DeleteFavoritedDiscountMutationReturn';
  favoritedDiscountDeletedSuccessfully: Scalars['Boolean']['output'];
};

export type DeletePerksLinkRequestReturn = {
  __typename?: 'DeletePerksLinkRequestReturn';
  perksLinkDeletedSuccessfully: Scalars['Boolean']['output'];
};

export type DeleteReturn = {
  __typename?: 'DeleteReturn';
  deleted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type DeleteUserMutationReturn = {
  __typename?: 'DeleteUserMutationReturn';
  deleted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type DeletedAndNonDeletedChamberMemberStatsReturn = {
  __typename?: 'DeletedAndNonDeletedChamberMemberStatsReturn';
  category1: Scalars['String']['output'];
  category2: Scalars['String']['output'];
  chamberName: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  createdAtUtcTimestamp: Scalars['String']['output'];
  hasLoggedInToAdminPortal: Scalars['String']['output'];
  hasLogo: Scalars['String']['output'];
  membershipStatus: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberOfAppUsersWithThisMemberSetAsTheirEmployer: Scalars['Float']['output'];
  numberOfDeletedAndNonDeletedDiscounts: Scalars['Float']['output'];
};

export type DeletedAndNonDeletedDiscountStatsReturn = {
  __typename?: 'DeletedAndNonDeletedDiscountStatsReturn';
  category1: Scalars['String']['output'];
  category2: Scalars['String']['output'];
  chamberMemberName: Scalars['String']['output'];
  chamberName: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  createdAtUtcTimestamp: Scalars['String']['output'];
  deletedAtUtcMilli: Scalars['Float']['output'];
  deletedAtUtcTimestamp: Scalars['String']['output'];
  numberOfRedemptions: Scalars['Float']['output'];
  offeredTo: Scalars['String']['output'];
  title: Scalars['String']['output'];
  views: Scalars['Float']['output'];
};

export type DeletedDiscountReturn = {
  __typename?: 'DeletedDiscountReturn';
  chamberId: Scalars['String']['output'];
  chamberInfo: ChamberReturn;
  chamberMemberId: Scalars['String']['output'];
  chamberMemberInfo: ChamberMemberReturn;
  createdAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  daysAvailable?: Maybe<Array<DayEnum>>;
  deletedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isAvailableToAllMembers?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  isReoccuring: Scalars['Boolean']['output'];
  memberOnly: Scalars['Boolean']['output'];
  monthsAvailable?: Maybe<Array<MonthEnum>>;
  numberOfFavorites: Scalars['Float']['output'];
  numberOfRedemptions: Scalars['Float']['output'];
  privateEmails?: Maybe<Array<Scalars['String']['output']>>;
  redeemSettings: RedeemSettingsReturn;
  title: Scalars['String']['output'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  views: Scalars['Float']['output'];
};

export type DeletedPerkPartnerDiscountReturn = {
  __typename?: 'DeletedPerkPartnerDiscountReturn';
  availableToChamberIds?: Maybe<Array<Scalars['String']['output']>>;
  banner?: Maybe<Array<BannerReturn>>;
  companyName: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  deletedAtUtcMilli: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  title: Scalars['String']['output'];
  unverifiedChamberMemberCapUserRedirectLink: Scalars['String']['output'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  verifiedChamberMemberCapUserRedirectLink: Scalars['String']['output'];
};

export type DeletedPerksLinkRequestReturn = {
  __typename?: 'DeletedPerksLinkRequestReturn';
  createdAtUtcMilli: Scalars['Float']['output'];
  deletedAtUtcMilli: Scalars['Float']['output'];
  deletionReason: PerksLinkDeletionReasonEnum;
  linkedAtTimeUtcMilli?: Maybe<Scalars['Float']['output']>;
  requesteeChamberId: Scalars['String']['output'];
  requestorChamberId: Scalars['String']['output'];
  status: PerksLinkRequestStatusEnum;
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
};

export type DiscountFilterEventInput = {
  chamberId: Scalars['String']['input'];
  chamberMemberId?: InputMaybe<Scalars['String']['input']>;
  sort: Scalars['String']['input'];
  stringifiedCategories: Scalars['String']['input'];
};

export type DiscountInUserPolygonBoundaryCoordsReturn = {
  __typename?: 'DiscountInUserPolygonBoundaryCoordsReturn';
  chamberMemberLocationCoords: CoordinateReturn;
  id: Scalars['String']['output'];
};

export type DiscountInput = {
  banner?: InputMaybe<Array<BannerInput>>;
  chamberId: Scalars['String']['input'];
  chamberMemberId: Scalars['String']['input'];
  daysAvailable?: InputMaybe<Array<DayEnum>>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiryTimeUtcMilli?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  isAvailableToAllMembers?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  isReoccuring: Scalars['Boolean']['input'];
  memberOnly: Scalars['Boolean']['input'];
  monthsAvailable?: InputMaybe<Array<MonthEnum>>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  privateEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  redeemSettings: RedeemSettingsInput;
  startTimeUtcMilli?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};

export enum DiscountNotificationTypes {
  NearbyDiscount = 'NEARBY_DISCOUNT',
  NearbyDiscountOpenProfile = 'NEARBY_DISCOUNT_OPEN_PROFILE',
  NewDiscount = 'NEW_DISCOUNT',
  RewardCampaign = 'REWARD_CAMPAIGN',
  ShopLocalCampaign = 'SHOP_LOCAL_CAMPAIGN'
}

export type DiscountReturn = {
  __typename?: 'DiscountReturn';
  activeShopLocalCampaignInfo?: Maybe<ShopLocalCampaignReturn>;
  banner?: Maybe<Array<BannerReturn>>;
  chamberId: Scalars['String']['output'];
  chamberInfo: ChamberReturn;
  chamberMemberId: Scalars['String']['output'];
  chamberMemberInfo: ChamberMemberReturn;
  chamberMemberIsSuspended?: Maybe<Scalars['Boolean']['output']>;
  chamberMemberLocationCoords?: Maybe<CoordinateReturn>;
  createdAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  currentLoggedInCapUserHasFavorited?: Maybe<Scalars['Boolean']['output']>;
  currentLoggedInCapUserHasRedeemed?: Maybe<Scalars['Boolean']['output']>;
  currentLoggedInCapUserIsInPrizeDrawOfActiveShopLocalCampaignUnderDiscountsMember?: Maybe<Scalars['Boolean']['output']>;
  daysAvailable?: Maybe<Array<DayEnum>>;
  description?: Maybe<Scalars['String']['output']>;
  expiryTimeUtcMilli?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isAvailableToAllMembers?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  isReoccuring: Scalars['Boolean']['output'];
  memberOnly: Scalars['Boolean']['output'];
  monthsAvailable?: Maybe<Array<MonthEnum>>;
  notify?: Maybe<Scalars['Boolean']['output']>;
  numberOfFavorites: Scalars['Float']['output'];
  numberOfRedemptions: Scalars['Float']['output'];
  openStreetMapsGeneratedProvince?: Maybe<Scalars['String']['output']>;
  privateEmails?: Maybe<Array<Scalars['String']['output']>>;
  redeemSettings: RedeemSettingsReturn;
  showRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']['output']>;
  startTimeUtcMilli?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  views: Scalars['Float']['output'];
};

export type DiscountsPerCategoryBreakdownReturn = {
  __typename?: 'DiscountsPerCategoryBreakdownReturn';
  categoryName: Scalars['String']['output'];
  numberOfDiscounts: Scalars['Float']['output'];
  percentageVersusOtherCategories: Scalars['Float']['output'];
};

export type EmailUserVerificationCodeMutationReturn = {
  __typename?: 'EmailUserVerificationCodeMutationReturn';
  emailUserVerificationCodeSentSuccessfully: Scalars['Boolean']['output'];
};

export type EndRewardCampaignMutationReturn = {
  __typename?: 'EndRewardCampaignMutationReturn';
  campaignEndedSuccessfully: Scalars['Boolean']['output'];
};

export type EndShopLocalCampaignReturn = {
  __typename?: 'EndShopLocalCampaignReturn';
  shopLocalCampaignEndedSuccessfully: Scalars['Boolean']['output'];
};

export enum ErrorCodeEnum {
  DisallowAccessTokenPermanently = 'DISALLOW_ACCESS_TOKEN_PERMANENTLY',
  DisallowAccessTokenWithUserAuthYoungerThanUtcMilli = 'DISALLOW_ACCESS_TOKEN_WITH_USER_AUTH_YOUNGER_THAN_UTC_MILLI',
  DisallowUserTypeAccess = 'DISALLOW_USER_TYPE_ACCESS'
}

export enum EventTypeEnum {
  ChangeChamber = 'CHANGE_CHAMBER',
  DiscountFilter = 'DISCOUNT_FILTER',
  NavbarButtonTap = 'NAVBAR_BUTTON_TAP',
  PerkPartner = 'PERK_PARTNER'
}

export type ExcludeChamberEngageActivationFromInvoiceReturn = {
  __typename?: 'ExcludeChamberEngageActivationFromInvoiceReturn';
  excluded: Scalars['Boolean']['output'];
};

export type FavoritedChamberMemberReturn = {
  __typename?: 'FavoritedChamberMemberReturn';
  chamberMemberId: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type FavoritedDiscountReturn = {
  __typename?: 'FavoritedDiscountReturn';
  createdAtUtcMilli: Scalars['Float']['output'];
  discountId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type GetAllMemberLoginCredentialsReturn = {
  __typename?: 'GetAllMemberLoginCredentialsReturn';
  status: GetAllMemberLoginCredentialsStatusEnum;
  successCSVRawTextOfAllMemberLoginCredentials?: Maybe<Scalars['String']['output']>;
};

export enum GetAllMemberLoginCredentialsStatusEnum {
  Failure = 'FAILURE',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export type GetSampleMemberLoginCredentialsReturn = {
  __typename?: 'GetSampleMemberLoginCredentialsReturn';
  sampleCSVRawTextOfAllMemberLoginCredentials: Scalars['String']['output'];
};

export type HardcodedChamberAddressReturn = {
  __typename?: 'HardcodedChamberAddressReturn';
  city: Scalars['String']['output'];
  province: Scalars['String']['output'];
};

export type HardcodedChamberReturn = {
  __typename?: 'HardcodedChamberReturn';
  address: HardcodedChamberAddressReturn;
  coordinates?: Maybe<CoordinateReturn>;
  fullProvinceName: Scalars['String']['output'];
  googleMapsApi_City_ProvinceShort_CountryShort: Scalars['String']['output'];
  id: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type HowToRedeemInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  websiteToEnterCodeAt?: InputMaybe<Scalars['String']['input']>;
};

export type HowToRedeemReturn = {
  __typename?: 'HowToRedeemReturn';
  code?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  websiteToEnterCodeAt?: Maybe<Scalars['String']['output']>;
};

export enum InAppShareTypes {
  ChamberMemberProfile = 'CHAMBER_MEMBER_PROFILE',
  Discount = 'DISCOUNT'
}

export type IncludeChamberEngageActivationInInvoiceReturn = {
  __typename?: 'IncludeChamberEngageActivationInInvoiceReturn';
  included: Scalars['Boolean']['output'];
};

export type IncrementChamberMemberViewCountReturn = {
  __typename?: 'IncrementChamberMemberViewCountReturn';
  incrementSuccessful: Scalars['Boolean']['output'];
};

export type IndividualRewardCampaignChallengeReturn = {
  __typename?: 'IndividualRewardCampaignChallengeReturn';
  ballotsEarnedForCapUser: Scalars['Float']['output'];
  ballotsNeededToComplete: Scalars['Float']['output'];
  challengeType: RewardCampaignChallengeTypeEnum;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  showRedBubbleNotificationForNewShareForCurrentlyLoggedInCapUser: Scalars['Boolean']['output'];
};

export type IneligiblePerkPartnerDiscountReturn = {
  __typename?: 'IneligiblePerkPartnerDiscountReturn';
  companyName: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
};

export enum ItemsPurchasableByChamberEnum {
  ChamberMemberPro = 'CHAMBER_MEMBER_PRO',
  ChamberMemberProWebsiteBuilderOnly = 'CHAMBER_MEMBER_PRO_WEBSITE_BUILDER_ONLY',
  ChamberPerksApp = 'CHAMBER_PERKS_APP'
}

export enum LanguageCodeEnum {
  En = 'EN',
  Fr = 'FR'
}

export enum LoginInfoEmailTypes {
  BrandNew = 'BRAND_NEW',
  ChangeEmailUsername = 'CHANGE_EMAIL_USERNAME',
  ResetPassword = 'RESET_PASSWORD'
}

export type MarkChamberEngageActivationInvoicedReturn = {
  __typename?: 'MarkChamberEngageActivationInvoicedReturn';
  marked: Scalars['Boolean']['output'];
};

export type MassSendLoginInfoEmailReturn = {
  __typename?: 'MassSendLoginInfoEmailReturn';
  failureCount: Scalars['Float']['output'];
  successCount: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export enum MemberProfileAndPerksBannersUpdateRecordEventEnum {
  Activation = 'ACTIVATION',
  ActivationFeeUpdateDoneByCpa = 'ACTIVATION_FEE_UPDATE_DONE_BY_CPA',
  ChamberMemberAgreementAcceptance = 'CHAMBER_MEMBER_AGREEMENT_ACCEPTANCE',
  Deactivation = 'DEACTIVATION',
  Expiration = 'EXPIRATION',
  Reactivation = 'REACTIVATION'
}

export type MemberProfileAndPerksBannersUpdateRecordReturn = {
  __typename?: 'MemberProfileAndPerksBannersUpdateRecordReturn';
  activationDateUtcMilli: Scalars['Float']['output'];
  chamberId: Scalars['String']['output'];
  chamberMemberId: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  excludeFromInvoice?: Maybe<Scalars['Boolean']['output']>;
  expirationDateUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  invoiceSentAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  memberProfileAndPerksBannersSettingsAtEventTrigger: ActiveMemberProfileAndPerksBannersSettingsReturn;
  recordEvent: MemberProfileAndPerksBannersUpdateRecordEventEnum;
  triggeringUserId: Scalars['String']['output'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
};

export enum MonthEnum {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMember: AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberReturn;
  acceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMember: AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberReturn;
  acceptPerksLinkRequest: AcceptPerksLinkRequestReturn;
  activateBannerForCategoryAdvertisingBanner: ActivateBannerForCategoryAdvertisingBannerReturn;
  activateMemberProfileAndPerksBannersForChamberMember: ActivateMemberProfileAndPerksBannersForChamberMemberReturn;
  capUserAgreedToRewardCampaign?: Maybe<CapUserAgreedToRewardCampaignMutationReturn>;
  capUserViewedRewardCampaign?: Maybe<CapUserViewedRewardCampaignMutationReturn>;
  chamberChangeAdminConsoleLoginEmail: ChangeAdminConsoleLoginEmailReturn;
  chamberMemberChangeAdminConsoleLoginEmail: ChangeAdminConsoleLoginEmailReturn;
  changeAutoApprovalForBannerContentOfCategoryAdvertisingBanner: ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerReturn;
  createAllMemberLoginCredentials: CreateAllMemberLoginCredentialsReturn;
  createCapUserShareLeadingToOpenRecord: CreateCapUserShareLeadingToOpenRecordMutationReturn;
  createChamberContactableCompany: ContactableCompanyReturn;
  createChamberMembers: CreateChamberMembersMutationReturn;
  createChambers: CreateChamberMutationReturn;
  createContactableChamber: ContactableChamberReturn;
  createDiscounts: CreateDiscountsMutationReturn;
  createFavoritedChamberMember: CreateFavoritedChamberMemberMutationReturn;
  createFavoritedDiscount: CreateFavoritedDiscountMutationReturn;
  createPerkPartnerDiscount: CreatePerkPartnerDiscountMutationReturn;
  createPerkPartnerDiscountAdminUser: CreatePerkPartnerDiscountAdminUserMutationReturn;
  createRedeemedDiscount: CreateRedeemedDiscountMutationReturn;
  createRedeemedDiscounts: CreateRedeemedDiscountsMutationReturn;
  createRewardCampaign: CreateRewardCampaignMutationReturn;
  createShopLocalCampaign: CreateShopLocalCampaignReturn;
  createShopLocalCampaignPrizeDrawParticipant: CreateShopLocalCampaignPrizeDrawParticipantReturn;
  createUsers: CreateUserMutationReturn;
  deactivateMemberProfileAndPerksBannersForChamberMember: DeactivateMemberProfileAndPerksBannersForChamberMemberReturn;
  deleteChamber: DeleteReturn;
  deleteChamberMember: DeleteReturn;
  deleteDiscount: DeleteReturn;
  deleteFavoritedChamberMember: DeleteFavoritedChamberMemberMutationReturn;
  deleteFavoritedDiscount: DeleteFavoritedDiscountMutationReturn;
  deletePerkPartnerDiscount: DeleteReturn;
  deletePerkPartnerDiscountAdminUser: DeleteReturn;
  deletePerksLinkRequest: DeletePerksLinkRequestReturn;
  deleteUser: DeleteUserMutationReturn;
  emailUserVerificationCode: EmailUserVerificationCodeMutationReturn;
  endRewardCampaign: EndRewardCampaignMutationReturn;
  endShopLocalCampaign: EndShopLocalCampaignReturn;
  excludeChamberEngageActivationFromInvoice: ExcludeChamberEngageActivationFromInvoiceReturn;
  getSupportCenterUrl: Scalars['String']['output'];
  includeChamberEngageActivationInInvoice: IncludeChamberEngageActivationInInvoiceReturn;
  incrementChamberMemberViewCount: IncrementChamberMemberViewCountReturn;
  incrementDiscountViewCount: UpdateDiscountReturn;
  markChamberEngageActivationInvoiced: MarkChamberEngageActivationInvoicedReturn;
  massSendLoginInfoEmail: MassSendLoginInfoEmailReturn;
  reactivateBannerForCategoryAdvertisingBanner: ActivateBannerForCategoryAdvertisingBannerReturn;
  reactivateMemberProfileAndPerksBannersForChamberMember: ActivateMemberProfileAndPerksBannersForChamberMemberReturn;
  requestPerksLink: RequestPerksLinkReturn;
  sendLoginInfoEmailToChamberMember: SendLoginInfoEmailToChamberMemberReturn;
  setHasSignedUpForChamberMember: SetHasSignedUpForChamberMemberReturn;
  setNewTemporaryChamberMemberPassword: NewTemporaryChamberMemberPasswordReturn;
  submitCMPBetaFeedback: SubmitBetaFeedbackReturn;
  updateBannerContentForCategoryAdvertisingBanner: ActivateBannerForCategoryAdvertisingBannerReturn;
  updateChamber: ChamberReturn;
  updateChamberEngageSettingsForChamber: UpdateChamberEngageSettingsForChamberReturn;
  updateChamberMember: ChamberMemberReturn;
  updateDiscount: UpdateDiscountReturn;
  updateLoggedInUserLanguage: UpdateLoggedInUserLanguageMutationReturn;
  updateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivation: UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationReturn;
  updatePerkPartnerDiscount: UpdatePerkPartnerDiscountReturn;
  updateRewardCampaign: UpdateRewardCampaignMutationReturn;
  updateShopLocalCampaign: UpdateShopLocalCampaignReturn;
  updateUser: UpdateUserMutationReturn;
  upsertCapUserShareRecord: UpsertCapUserShareRecordMutationReturn;
  upsertRedBubbleNotificationView: UpsertRedBubbleNotificationViewReturn;
  verifyUserVerificationCode: VerifyUserVerificationCodeMutationReturn;
};


export type MutationAcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberArgs = {
  categoryId: ChamberMemberCategory;
};


export type MutationAcceptPerksLinkRequestArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationActivateBannerForCategoryAdvertisingBannerArgs = {
  activationInfo: CategoryAdvertisingBannerActivationInfoInput;
  categoryId: ChamberMemberCategory;
  chamberId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationActivateMemberProfileAndPerksBannersForChamberMemberArgs = {
  chamberId?: InputMaybe<Scalars['String']['input']>;
  chamberMemberId: Scalars['String']['input'];
  startDateUtcMilli: Scalars['Float']['input'];
};


export type MutationCapUserAgreedToRewardCampaignArgs = {
  rewardCampaignId: Scalars['String']['input'];
};


export type MutationCapUserViewedRewardCampaignArgs = {
  rewardCampaignId: Scalars['String']['input'];
};


export type MutationChamberChangeAdminConsoleLoginEmailArgs = {
  chamberId: Scalars['String']['input'];
  currentAdminConsoleLoginEmail: Scalars['String']['input'];
  newAdminConsoleLoginEmail: Scalars['String']['input'];
};


export type MutationChamberMemberChangeAdminConsoleLoginEmailArgs = {
  chamberMemberId: Scalars['String']['input'];
  currentAdminConsoleLoginEmail: Scalars['String']['input'];
  newAdminConsoleLoginEmail: Scalars['String']['input'];
};


export type MutationChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerArgs = {
  autoApproveBannerContentUpdate: Scalars['Boolean']['input'];
  categoryId: ChamberMemberCategory;
  chamberId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCapUserShareLeadingToOpenRecordArgs = {
  input: CapUserShareLeadingToOpenRecordInput;
};


export type MutationCreateChamberContactableCompanyArgs = {
  input: CreateChamberContactableCompanyMutationInput;
};


export type MutationCreateChamberMembersArgs = {
  input: CreateChamberMembersMutationInput;
};


export type MutationCreateChambersArgs = {
  input: CreateChamberMutationInput;
};


export type MutationCreateContactableChamberArgs = {
  input: CreateContactableChamberMutationInput;
};


export type MutationCreateDiscountsArgs = {
  input: CreateDiscountsMutationInput;
};


export type MutationCreateFavoritedChamberMemberArgs = {
  chamberMemberId: Scalars['String']['input'];
};


export type MutationCreateFavoritedDiscountArgs = {
  discountId: Scalars['String']['input'];
};


export type MutationCreatePerkPartnerDiscountArgs = {
  input: PerkPartnerDiscountInput;
};


export type MutationCreatePerkPartnerDiscountAdminUserArgs = {
  input: PerkPartnerDiscountAdminUserInput;
};


export type MutationCreateRedeemedDiscountArgs = {
  discountId: Scalars['String']['input'];
};


export type MutationCreateRedeemedDiscountsArgs = {
  input: CreateRedeemedDiscountsMutationInput;
};


export type MutationCreateRewardCampaignArgs = {
  input: RewardCampaignInput;
};


export type MutationCreateShopLocalCampaignArgs = {
  input: ShopLocalCampaignInput;
};


export type MutationCreateShopLocalCampaignPrizeDrawParticipantArgs = {
  participatingForDiscountId: Scalars['String']['input'];
  participatingForMemberId: Scalars['String']['input'];
  participationCode: Scalars['String']['input'];
  shopLocalCampaignId: Scalars['String']['input'];
};


export type MutationCreateUsersArgs = {
  input: CreateUserMutationInput;
};


export type MutationDeactivateMemberProfileAndPerksBannersForChamberMemberArgs = {
  chamberId?: InputMaybe<Scalars['String']['input']>;
  chamberMemberId: Scalars['String']['input'];
};


export type MutationDeleteChamberArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteChamberMemberArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDiscountArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFavoritedChamberMemberArgs = {
  chamberMemberId: Scalars['String']['input'];
};


export type MutationDeleteFavoritedDiscountArgs = {
  discountId: Scalars['String']['input'];
};


export type MutationDeletePerkPartnerDiscountArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePerkPartnerDiscountAdminUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePerksLinkRequestArgs = {
  deletionReason: PerksLinkDeletionReasonEnum;
  requestId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationEndRewardCampaignArgs = {
  id: Scalars['String']['input'];
};


export type MutationEndShopLocalCampaignArgs = {
  id: Scalars['String']['input'];
};


export type MutationExcludeChamberEngageActivationFromInvoiceArgs = {
  activationId: Scalars['String']['input'];
  activationType: ChamberEngageActivationTypeEnum;
};


export type MutationGetSupportCenterUrlArgs = {
  nonce: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationIncludeChamberEngageActivationInInvoiceArgs = {
  activationId: Scalars['String']['input'];
  activationType: ChamberEngageActivationTypeEnum;
};


export type MutationIncrementChamberMemberViewCountArgs = {
  id: Scalars['String']['input'];
};


export type MutationIncrementDiscountViewCountArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkChamberEngageActivationInvoicedArgs = {
  activationsToMarkInvoiced: Array<ChamberEngageActivationToMarkInvoicedInput>;
};


export type MutationReactivateBannerForCategoryAdvertisingBannerArgs = {
  categoryId: ChamberMemberCategory;
  chamberId?: InputMaybe<Scalars['String']['input']>;
  reactivationInfo: CategoryAdvertisingBannerReactivationInfoInput;
};


export type MutationReactivateMemberProfileAndPerksBannersForChamberMemberArgs = {
  chamberId?: InputMaybe<Scalars['String']['input']>;
  chamberMemberId: Scalars['String']['input'];
};


export type MutationRequestPerksLinkArgs = {
  requestingLinkToChamberId: Scalars['String']['input'];
};


export type MutationSendLoginInfoEmailToChamberMemberArgs = {
  adminConsoleLoginEmail: Scalars['String']['input'];
  chamberMemberId: Scalars['String']['input'];
  type: LoginInfoEmailTypes;
};


export type MutationSetNewTemporaryChamberMemberPasswordArgs = {
  adminConsoleLoginEmail: Scalars['String']['input'];
  chamberMemberId: Scalars['String']['input'];
};


export type MutationSubmitCmpBetaFeedbackArgs = {
  feedback: Scalars['String']['input'];
  urlPath: Scalars['String']['input'];
};


export type MutationUpdateBannerContentForCategoryAdvertisingBannerArgs = {
  banner?: InputMaybe<Array<BannerInput>>;
  categoryId: ChamberMemberCategory;
  chamberId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateChamberArgs = {
  id: Scalars['String']['input'];
  input: ChamberInput;
};


export type MutationUpdateChamberEngageSettingsForChamberArgs = {
  chamberEngageSettings: ChamberEngageSettingsInput;
  chamberId: Scalars['String']['input'];
};


export type MutationUpdateChamberMemberArgs = {
  id: Scalars['String']['input'];
  input: ChamberMemberInput;
};


export type MutationUpdateDiscountArgs = {
  id: Scalars['String']['input'];
  input: DiscountInput;
};


export type MutationUpdateLoggedInUserLanguageArgs = {
  languageCode: LanguageCodeEnum;
};


export type MutationUpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationArgs = {
  activationId: Scalars['String']['input'];
  newActivationFeeInDollars: Scalars['Float']['input'];
};


export type MutationUpdatePerkPartnerDiscountArgs = {
  id: Scalars['String']['input'];
  input: PerkPartnerDiscountInput;
};


export type MutationUpdateRewardCampaignArgs = {
  id: Scalars['String']['input'];
  input: RewardCampaignInput;
};


export type MutationUpdateShopLocalCampaignArgs = {
  id: Scalars['String']['input'];
  input: ShopLocalCampaignInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['String']['input'];
  input: UserInput;
};


export type MutationUpsertCapUserShareRecordArgs = {
  shareType: InAppShareTypes;
  sharedItemId: Scalars['String']['input'];
};


export type MutationUpsertRedBubbleNotificationViewArgs = {
  viewType: RedBubbleNotificationViewTypeEnum;
  viewTypeItemId: Scalars['String']['input'];
};


export type MutationVerifyUserVerificationCodeArgs = {
  code: Scalars['String']['input'];
};

export enum NavBarButtonNameEnum {
  AdvocacyWins = 'ADVOCACY_WINS',
  BecomeAMember = 'BECOME_A_MEMBER',
  Directory = 'DIRECTORY',
  Events = 'EVENTS',
  JobPosts = 'JOB_POSTS',
  MyChamber = 'MY_CHAMBER',
  Newsletter = 'NEWSLETTER',
  Perks = 'PERKS',
  PerkPartners = 'PERK_PARTNERS',
  Rewards = 'REWARDS',
  Survey = 'SURVEY'
}

export type NavBarButtonTapEventInput = {
  buttonName: NavBarButtonNameEnum;
  chamberId: Scalars['String']['input'];
  chamberMemberId?: InputMaybe<Scalars['String']['input']>;
};

export type NewTemporaryChamberMemberPasswordReturn = {
  __typename?: 'NewTemporaryChamberMemberPasswordReturn';
  failureReason?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
};

export type PerkPartnerDiscountAdminUserInput = {
  adminConsoleLoginEmail: Scalars['String']['input'];
  perkPartnerDiscountId: Scalars['String']['input'];
};

export type PerkPartnerDiscountAdminUserReturn = {
  __typename?: 'PerkPartnerDiscountAdminUserReturn';
  adminConsoleLoginEmail: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  perkPartnerDiscountId: Scalars['String']['output'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
};

export type PerkPartnerDiscountInput = {
  availableToChamberIds?: InputMaybe<Array<Scalars['String']['input']>>;
  banner?: InputMaybe<Array<BannerInput>>;
  companyName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  logo: Scalars['String']['input'];
  title: Scalars['String']['input'];
  unverifiedChamberMemberCapUserRedirectLink: Scalars['String']['input'];
  verifiedChamberMemberCapUserRedirectLink: Scalars['String']['input'];
};

export type PerkPartnerDiscountReturn = {
  __typename?: 'PerkPartnerDiscountReturn';
  availableToChamberIds?: Maybe<Array<Scalars['String']['output']>>;
  availableToChambers?: Maybe<Array<RootAdminPerkPartnerDiscountAvailableToChambersReturn>>;
  banner?: Maybe<Array<BannerReturn>>;
  companyName: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  showRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  unverifiedChamberMemberCapUserRedirectLink: Scalars['String']['output'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  verifiedChamberMemberCapUserRedirectLink: Scalars['String']['output'];
};

export type PerkPartnerDiscountStatReturn = {
  __typename?: 'PerkPartnerDiscountStatReturn';
  id: Scalars['String']['output'];
  splitByChamber?: Maybe<Array<PerkPartnerDiscountStatSplitByChamberReturn>>;
  timeseriesData?: Maybe<PerkPartnerDiscountTimeseriesDataReturn>;
  totalIneligibleOpenCount: Scalars['Float']['output'];
  totalIneligibleViewCount: Scalars['Float']['output'];
  totalOpenCount: Scalars['Float']['output'];
  totalOpensFromViewsConversionRatePercentage: Scalars['Float']['output'];
  totalRedeemCount: Scalars['Float']['output'];
  totalRedeemCountFromOpensConversionRatePercentage: Scalars['Float']['output'];
  totalUnverifiedOpenCount: Scalars['Float']['output'];
  totalUnverifiedRedeemCount: Scalars['Float']['output'];
  totalUnverifiedViewCount: Scalars['Float']['output'];
  totalVerifiedNoAccessToEmailRedeemCount: Scalars['Float']['output'];
  totalVerifiedOpenCount: Scalars['Float']['output'];
  totalVerifiedRedeemCount: Scalars['Float']['output'];
  totalVerifiedViewCount: Scalars['Float']['output'];
  totalViewCount: Scalars['Float']['output'];
};

export type PerkPartnerDiscountStatSplitByChamberReturn = {
  __typename?: 'PerkPartnerDiscountStatSplitByChamberReturn';
  chamberId: Scalars['String']['output'];
  chamberIsEnabledForPerkPartnerDiscount: Scalars['Boolean']['output'];
  chamberName: Scalars['String']['output'];
  ineligibleOpenCount: Scalars['Float']['output'];
  ineligibleViewCount: Scalars['Float']['output'];
  totalOpenCount: Scalars['Float']['output'];
  totalRedeemCount: Scalars['Float']['output'];
  totalViewCount: Scalars['Float']['output'];
  unverifiedOpenCount: Scalars['Float']['output'];
  unverifiedRedeemCount: Scalars['Float']['output'];
  unverifiedViewCount: Scalars['Float']['output'];
  verifiedNoAccessToEmailRedeemCount: Scalars['Float']['output'];
  verifiedOpenCount: Scalars['Float']['output'];
  verifiedRedeemCount: Scalars['Float']['output'];
  verifiedViewCount: Scalars['Float']['output'];
};

export type PerkPartnerDiscountTimeseriesDataPoint = {
  __typename?: 'PerkPartnerDiscountTimeseriesDataPoint';
  monthAndYear: Scalars['String']['output'];
  totalOpenCount: Scalars['Float']['output'];
  totalRedeemCount: Scalars['Float']['output'];
  totalViewCount: Scalars['Float']['output'];
};

export type PerkPartnerDiscountTimeseriesDataReturn = {
  __typename?: 'PerkPartnerDiscountTimeseriesDataReturn';
  allChambers: PerkPartnerDiscountTimeseriesDataset;
  chambers: Array<PerkPartnerDiscountTimeseriesDataset>;
};

export type PerkPartnerDiscountTimeseriesDataset = {
  __typename?: 'PerkPartnerDiscountTimeseriesDataset';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  timeseriesData: Array<PerkPartnerDiscountTimeseriesDataPoint>;
};

export type PerkPartnerDiscountUpdateRecordReturn = {
  __typename?: 'PerkPartnerDiscountUpdateRecordReturn';
  createdAtUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  newVersion: PerkPartnerDiscountReturn;
  perkPartnerDiscountId: Scalars['String']['output'];
  prevVersion: PerkPartnerDiscountReturn;
  updatingUsersAdminConsoleLoginEmail: Scalars['String']['output'];
  updatingUsersId: Scalars['String']['output'];
};

export enum PerkPartnerEventActionEnum {
  IneligibleOpen = 'INELIGIBLE_OPEN',
  IneligibleView = 'INELIGIBLE_VIEW',
  UnverifiedOpen = 'UNVERIFIED_OPEN',
  UnverifiedRedeem = 'UNVERIFIED_REDEEM',
  UnverifiedView = 'UNVERIFIED_VIEW',
  VerifiedNoAccessToEmailRedeem = 'VERIFIED_NO_ACCESS_TO_EMAIL_REDEEM',
  VerifiedOpen = 'VERIFIED_OPEN',
  VerifiedRedeem = 'VERIFIED_REDEEM',
  VerifiedView = 'VERIFIED_VIEW'
}

export type PerkPartnerEventInput = {
  action: PerkPartnerEventActionEnum;
  chamberId: Scalars['String']['input'];
  chamberMemberId?: InputMaybe<Scalars['String']['input']>;
  perkPartnerId: Scalars['String']['input'];
  redeemUserId?: InputMaybe<Scalars['String']['input']>;
};

export enum PerksLinkDeletionReasonEnum {
  Cancelled = 'CANCELLED',
  Denied = 'DENIED',
  Unlinked = 'UNLINKED'
}

export type PerksLinkRequestReturn = {
  __typename?: 'PerksLinkRequestReturn';
  createdAtUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  linkedAtTimeUtcMilli?: Maybe<Scalars['Float']['output']>;
  requesteeChamberId: Scalars['String']['output'];
  requestorChamberId: Scalars['String']['output'];
  status: PerksLinkRequestStatusEnum;
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
};

export enum PerksLinkRequestStatusEnum {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING'
}

export type PerksLinkReturn = {
  __typename?: 'PerksLinkReturn';
  chamberContactEmail: Scalars['String']['output'];
  chamberContactNumber: Scalars['String']['output'];
  chamberId: Scalars['String']['output'];
  chamberName: Scalars['String']['output'];
  pendingOrAcceptedPerksLinkRequestInfo?: Maybe<PerksLinkRequestReturn>;
};

export type PrizeDrawParticipantReturn = {
  __typename?: 'PrizeDrawParticipantReturn';
  ballotsEarned: Scalars['Float']['output'];
  email: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getActiveCategoryAdvertisingBannersForCapUser?: Maybe<Array<CategoryAdvertisingBannerReturn>>;
  getActiveCategoryAdvertisingBannersForChamberMember?: Maybe<Array<CategoryAdvertisingBannerReturn>>;
  getActiveRewardCampaignForCapUser?: Maybe<RewardCampaignReturn>;
  getActiveShopLocalCampaignForChamber?: Maybe<ShopLocalCampaignReturn>;
  getAdminConsoleLoginEmailForChamber: AdminConsoleLoginEmailReturn;
  getAdminConsoleLoginEmailForChamberMember: AdminConsoleLoginEmailReturn;
  getAllAdminUsersForPerkPartnerDiscount?: Maybe<Array<PerkPartnerDiscountAdminUserReturn>>;
  getAllCategories?: Maybe<Array<CategoryReturn>>;
  getAllCategoryAdvertisingBannersForChamber: AllCategoryAdvertisingBannersForChamberReturn;
  getAllChamberEngageInvoiceData?: Maybe<Array<ChamberEngageMonthlyInvoiceDataReturn>>;
  getAllChamberMembers?: Maybe<Array<ChamberMemberReturn>>;
  getAllChambers?: Maybe<Array<ChamberReturn>>;
  getAllContactableCompaniesForChamber?: Maybe<Array<ContactableCompanyReturn>>;
  getAllDeletedDiscountsFromChamberId?: Maybe<Array<DeletedDiscountReturn>>;
  getAllDeletedPerkPartnerDiscounts?: Maybe<Array<DeletedPerkPartnerDiscountReturn>>;
  getAllDiscountsFromChamberId?: Maybe<Array<DiscountReturn>>;
  getAllDiscountsFromChamberMemberId?: Maybe<Array<DiscountReturn>>;
  getAllDiscountsInUserPolygonBoundaryCoords?: Maybe<Array<DiscountInUserPolygonBoundaryCoordsReturn>>;
  getAllMemberLoginCredentials: GetAllMemberLoginCredentialsReturn;
  getAllPerkPartnerDiscounts?: Maybe<Array<PerkPartnerDiscountReturn>>;
  getAllPerkPartnerDiscountsForCapUser?: Maybe<CapUserPerkPartnerDiscountReturn>;
  getAllPerksLinksForChamber: Array<PerksLinkReturn>;
  getAllRewardCampaignsForChamber?: Maybe<Array<RewardCampaignReturn>>;
  getAllShopLocalCampaignsForChamber?: Maybe<Array<ShopLocalCampaignReturn>>;
  getCPASignUpChambersForCity: CpaSignUpChambersForCityReturn;
  getChamber: ChamberReturn;
  getChamberMember: ChamberMemberReturn;
  getDiscount: DiscountReturn;
  getHardcodedChambers?: Maybe<Array<Maybe<HardcodedChamberReturn>>>;
  getPerkPartnerDiscount: PerkPartnerDiscountReturn;
  getPerkPartnerDiscountAdminUser: PerkPartnerDiscountAdminUserReturn;
  getPerkPartnerDiscountStats: PerkPartnerDiscountStatReturn;
  getRewardCampaign?: Maybe<RewardCampaignReturn>;
  getRootAdminStats: RootAdminStatsReturn;
  getSampleLoginInfoEmail: SampleLoginInfoEmailReturn;
  getSampleMemberLoginCredentials: GetSampleMemberLoginCredentialsReturn;
  getShopLocalCampaign?: Maybe<ShopLocalCampaignReturn>;
  getSystemWidePerkStats: SystemWidePerkStatsReturn;
  getUnverifiedCpaUserInfo: UnverifiedCpaUserInfoReturn;
  getUser: UserReturn;
  getUserIsEligibleBoolAndSendNotificationForEachEligibleNearbyDiscount?: Maybe<Array<UserIsEligibleBoolAndSendNotificationForEachEligibleNearbyDiscountReturn>>;
};


export type QueryGetAdminConsoleLoginEmailForChamberArgs = {
  chamberId: Scalars['String']['input'];
};


export type QueryGetAdminConsoleLoginEmailForChamberMemberArgs = {
  chamberMemberId: Scalars['String']['input'];
};


export type QueryGetAllAdminUsersForPerkPartnerDiscountArgs = {
  perkPartnerDiscountId: Scalars['String']['input'];
};


export type QueryGetAllCategoryAdvertisingBannersForChamberArgs = {
  chamberId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllChamberMembersArgs = {
  chamberId: Scalars['String']['input'];
  getHasSignedUp?: InputMaybe<Scalars['Boolean']['input']>;
  getNumberOfUsers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetAllChambersArgs = {
  getAllSandbox?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetAllDeletedDiscountsFromChamberIdArgs = {
  chamberId: Scalars['String']['input'];
};


export type QueryGetAllDiscountsFromChamberIdArgs = {
  chamberId: Scalars['String']['input'];
  localDay?: InputMaybe<DayEnum>;
  localMonth?: InputMaybe<MonthEnum>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllDiscountsFromChamberMemberIdArgs = {
  chamberMemberId: Scalars['String']['input'];
  localDay?: InputMaybe<DayEnum>;
  localMonth?: InputMaybe<MonthEnum>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllDiscountsInUserPolygonBoundaryCoordsArgs = {
  localDay?: InputMaybe<DayEnum>;
  localMonth?: InputMaybe<MonthEnum>;
  openStreetMapsGeneratedProvinceForUserCurrentCoords: Scalars['String']['input'];
  userPolygonBoundaryCoords: Array<InputMaybe<Array<InputMaybe<Array<Scalars['Float']['input']>>>>>;
};


export type QueryGetAllMemberLoginCredentialsArgs = {
  processId: Scalars['String']['input'];
};


export type QueryGetCpaSignUpChambersForCityArgs = {
  googleMapsApiCityPlaceId?: InputMaybe<Scalars['String']['input']>;
  googleMapsApiFullCityAddressSearchText: Scalars['String']['input'];
  googleMapsApi_City_ProvinceShort_CountryShort: Scalars['String']['input'];
};


export type QueryGetChamberArgs = {
  chamberId: Scalars['String']['input'];
};


export type QueryGetChamberMemberArgs = {
  chamberMemberId: Scalars['String']['input'];
};


export type QueryGetDiscountArgs = {
  discountId: Scalars['String']['input'];
};


export type QueryGetPerkPartnerDiscountArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPerkPartnerDiscountStatsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetRewardCampaignArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetSampleLoginInfoEmailArgs = {
  chamberMemberId?: InputMaybe<Scalars['String']['input']>;
  type: LoginInfoEmailTypes;
};


export type QueryGetShopLocalCampaignArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetUnverifiedCpaUserInfoArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserIsEligibleBoolAndSendNotificationForEachEligibleNearbyDiscountArgs = {
  discountIds: Array<Scalars['String']['input']>;
  localDay?: InputMaybe<DayEnum>;
  localMonth?: InputMaybe<MonthEnum>;
};

export type RedBubbleNotificationViewReturn = {
  __typename?: 'RedBubbleNotificationViewReturn';
  createdAtUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  viewType: RedBubbleNotificationViewTypeEnum;
  viewTypeItemId: Scalars['String']['output'];
  viewedAtUtcMilli: Scalars['Float']['output'];
};

export enum RedBubbleNotificationViewTypeEnum {
  AdvocacyWins = 'ADVOCACY_WINS',
  ChamberMember = 'CHAMBER_MEMBER',
  Discount = 'DISCOUNT',
  Events = 'EVENTS',
  JobPosts = 'JOB_POSTS',
  Newsletter = 'NEWSLETTER',
  PerkPartnerDiscount = 'PERK_PARTNER_DISCOUNT',
  Survey = 'SURVEY'
}

export type RedeemSettingsInput = {
  howToRedeem?: InputMaybe<HowToRedeemInput>;
  whereToRedeem: WhereToRedeemEnum;
};

export type RedeemSettingsReturn = {
  __typename?: 'RedeemSettingsReturn';
  howToRedeem?: Maybe<HowToRedeemReturn>;
  whereToRedeem: WhereToRedeemEnum;
};

export type RedeemedDiscountInput = {
  discountId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  redeemUtcMilli: Scalars['Float']['input'];
  userId: Scalars['String']['input'];
};

export type RedeemedDiscountReturn = {
  __typename?: 'RedeemedDiscountReturn';
  createdAtUtcMilli: Scalars['Float']['output'];
  discountId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type RequestPerksLinkReturn = {
  __typename?: 'RequestPerksLinkReturn';
  perksLinkRequestedSuccessfully: Scalars['Boolean']['output'];
};

export enum RewardCampaignChallengeTypeEnum {
  ShareChamberMember = 'SHARE_CHAMBER_MEMBER',
  ShareDiscount = 'SHARE_DISCOUNT',
  ShareDiscountOrChamberMemberLeadingToNewUser = 'SHARE_DISCOUNT_OR_CHAMBER_MEMBER_LEADING_TO_NEW_USER'
}

export type RewardCampaignInput = {
  campaignName: Scalars['String']['input'];
  endDateUtcMilli: Scalars['Float']['input'];
  prizeDescription: Scalars['String']['input'];
  sponsoringChamberMemberId: Scalars['String']['input'];
  startDateUtcMilli: Scalars['Float']['input'];
};

export type RewardCampaignReturn = {
  __typename?: 'RewardCampaignReturn';
  campaignName: Scalars['String']['output'];
  capUserHasNeverViewedCampaign: Scalars['Boolean']['output'];
  challengeConfig: Array<IndividualRewardCampaignChallengeReturn>;
  chamberId: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  currentlyLoggedInCapUserHasAgreedToCampaign: Scalars['Boolean']['output'];
  currentlyLoggedInCapUserHasCompletedAllChallenges: Scalars['Boolean']['output'];
  endDateUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isCreatedByCpaAdmin?: Maybe<Scalars['Boolean']['output']>;
  numberOfBonusBallotsWhenAllChallengesCompleted: Scalars['Float']['output'];
  prizeDescription: Scalars['String']['output'];
  prizeDrawParticipants?: Maybe<Array<PrizeDrawParticipantReturn>>;
  sponsoringChamberMemberId: Scalars['String']['output'];
  startDateUtcMilli: Scalars['Float']['output'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
};

export type RootAdminPerkPartnerDiscountAvailableToChambersReturn = {
  __typename?: 'RootAdminPerkPartnerDiscountAvailableToChambersReturn';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RootAdminStatsReturn = {
  __typename?: 'RootAdminStatsReturn';
  chambersSortedByNewest: Array<ChambersStatsReturn>;
  contactableChambersSortedByNewest: Array<ContactableChamberReturn>;
  contactableCompaniesSortedByNewest: Array<ContactableCompanyReturn>;
  discountsPerCategoryBreakdown: Array<DiscountsPerCategoryBreakdownReturn>;
  newestChamberMembers: Array<DeletedAndNonDeletedChamberMemberStatsReturn>;
  newestDiscounts: Array<DeletedAndNonDeletedDiscountStatsReturn>;
  numberOfChamberMembersOfferingLiveDiscounts: Scalars['Float']['output'];
  percentOfChamberMembersOfferingLiveDiscounts: Scalars['Float']['output'];
  timeseriesAppUsersData: TimeSeriesAppUsersDataReturn;
  timeseriesChamberEngageData: TimeSeriesChamberEngageDataReturn;
  totalChamberMembers: Scalars['Float']['output'];
  totalChambers: Scalars['Float']['output'];
  totalDiscountRedemptions: Scalars['Float']['output'];
  totalDiscountViews: Scalars['Float']['output'];
  totalNumberOfAppUsers: Scalars['Float']['output'];
  totalNumberOfAppUsersSignedUpWithAnEmployer: Scalars['Float']['output'];
  totalNumberOfAppUsersSignedUpWithoutAnEmployer: Scalars['Float']['output'];
  totalNumberOfAppUsersWithNearbyPerkNotificationEnabled: Scalars['Float']['output'];
  totalNumberOfAppUsersWithNewPerkNotificationEnabled: Scalars['Float']['output'];
  totalNumberOfLiveAllMemberDiscounts: Scalars['Float']['output'];
  totalNumberOfLiveCompanyEmployeesOnlyDiscounts: Scalars['Float']['output'];
  totalNumberOfLiveDiscounts: Scalars['Float']['output'];
  totalNumberOfLiveGeneralPublicDiscounts: Scalars['Float']['output'];
  totalNumberOfLiveLocalMemberOnlyDiscounts: Scalars['Float']['output'];
  totalPercentageOfAppUsersWithNearbyPerkNotificationEnabled: Scalars['Float']['output'];
  totalPercentageOfAppUsersWithNewPerkNotificationEnabled: Scalars['Float']['output'];
  totalSuspendedChamberMembers: Scalars['Float']['output'];
};

export type SampleLoginInfoEmailReturn = {
  __typename?: 'SampleLoginInfoEmailReturn';
  emailHtml: Scalars['String']['output'];
};

export type SendLoginInfoEmailToChamberMemberReturn = {
  __typename?: 'SendLoginInfoEmailToChamberMemberReturn';
  loginInfoEmailSentSuccessfully: Scalars['Boolean']['output'];
};

export type SetHasSignedUpForChamberMemberReturn = {
  __typename?: 'SetHasSignedUpForChamberMemberReturn';
  successfullySetHasSignedUp: Scalars['Boolean']['output'];
};

export type ShopLocalCampaignInput = {
  campaignName: Scalars['String']['input'];
  endDateUtcMilli: Scalars['Float']['input'];
  participatingMembers: Array<ShopLocalCampaignParticipatingMembersInput>;
  prizeDescription: Scalars['String']['input'];
  startDateUtcMilli: Scalars['Float']['input'];
};

export type ShopLocalCampaignParticipatingMembersInput = {
  id: Scalars['String']['input'];
};

export type ShopLocalCampaignParticipatingMembersReturn = {
  __typename?: 'ShopLocalCampaignParticipatingMembersReturn';
  memberId: Scalars['String']['output'];
  participationCode: Scalars['String']['output'];
};

export type ShopLocalCampaignPrizeDrawPariticpantReturn = {
  __typename?: 'ShopLocalCampaignPrizeDrawPariticpantReturn';
  createdAtUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  participatingForDiscountId: Scalars['String']['output'];
  participatingForMemberId: Scalars['String']['output'];
  shopLocalCampaignId: Scalars['String']['output'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ShopLocalCampaignPrizeDrawParticipantsReturn = {
  __typename?: 'ShopLocalCampaignPrizeDrawParticipantsReturn';
  redeemedAtMemberIds: Array<Scalars['String']['output']>;
  userEmail: Scalars['String']['output'];
};

export type ShopLocalCampaignReturn = {
  __typename?: 'ShopLocalCampaignReturn';
  campaignName: Scalars['String']['output'];
  chamberId: Scalars['String']['output'];
  createdAtUtcMilli: Scalars['Float']['output'];
  endDateUtcMilli: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  participatingMemberIds: Array<Scalars['String']['output']>;
  participatingMembers: Array<ShopLocalCampaignParticipatingMembersReturn>;
  prizeDescription: Scalars['String']['output'];
  prizeDrawParticipants?: Maybe<Array<ShopLocalCampaignPrizeDrawParticipantsReturn>>;
  startDateUtcMilli: Scalars['Float']['output'];
  status: ShopLocalCampaignStatusEnum;
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
};

export enum ShopLocalCampaignStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type SignUpMultipleMatchingChambersReturn = {
  __typename?: 'SignUpMultipleMatchingChambersReturn';
  chamberMembersFromAllChambersInCity: Array<ChamberMemberReturn>;
  chambersInCity: Array<ChamberReturn>;
};

export type SignUpNoMatchingChambersReturn = {
  __typename?: 'SignUpNoMatchingChambersReturn';
  closestChambers: Array<ChamberReturn>;
};

export type SignUpSingleMatchingChamberReturn = {
  __typename?: 'SignUpSingleMatchingChamberReturn';
  chamberInfo: ChamberReturn;
  chamberMembers: Array<ChamberMemberReturn>;
};

export enum SortKey {
  AllCategoryAdvertisingBannersForChamber = 'ALL_CATEGORY_ADVERTISING_BANNERS_FOR_CHAMBER',
  CapUserAgreedToRewardCampaign = 'CAP_USER_AGREED_TO_REWARD_CAMPAIGN',
  CapUserShareLeadingToOpenRecord = 'CAP_USER_SHARE_LEADING_TO_OPEN_RECORD',
  CapUserShareRecord = 'CAP_USER_SHARE_RECORD',
  CapUserViewedRewardCampaign = 'CAP_USER_VIEWED_REWARD_CAMPAIGN',
  CategoryAdvertisingBannerUpdateRecord = 'CATEGORY_ADVERTISING_BANNER_UPDATE_RECORD',
  Chamber = 'CHAMBER',
  ChamberContactableCompany = 'CHAMBER_CONTACTABLE_COMPANY',
  ChamberMember = 'CHAMBER_MEMBER',
  ContactableChamber = 'CONTACTABLE_CHAMBER',
  DeletedDiscount = 'DELETED_DISCOUNT',
  DeletedPerksLinkRequest = 'DELETED_PERKS_LINK_REQUEST',
  DeletedPerkPartnerDiscount = 'DELETED_PERK_PARTNER_DISCOUNT',
  Discount = 'DISCOUNT',
  FavoritedChamberMember = 'FAVORITED_CHAMBER_MEMBER',
  FavoritedDiscount = 'FAVORITED_DISCOUNT',
  MemberProfileAndPerksBannersUpdateRecord = 'MEMBER_PROFILE_AND_PERKS_BANNERS_UPDATE_RECORD',
  PerksLinkRequest = 'PERKS_LINK_REQUEST',
  PerkPartnerDiscount = 'PERK_PARTNER_DISCOUNT',
  PerkPartnerDiscountUpdateRecord = 'PERK_PARTNER_DISCOUNT_UPDATE_RECORD',
  RedeemedDiscount = 'REDEEMED_DISCOUNT',
  RedBubbleNotificationView = 'RED_BUBBLE_NOTIFICATION_VIEW',
  RewardCampaign = 'REWARD_CAMPAIGN',
  ShopLocalCampaign = 'SHOP_LOCAL_CAMPAIGN',
  ShopLocalCampaignPrizeDrawParticipant = 'SHOP_LOCAL_CAMPAIGN_PRIZE_DRAW_PARTICIPANT',
  User = 'USER'
}

export type SubmitBetaFeedbackReturn = {
  __typename?: 'SubmitBetaFeedbackReturn';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SystemWidePerkStatsReturn = {
  __typename?: 'SystemWidePerkStatsReturn';
  numOfAllMemberPerks: Scalars['Float']['output'];
  numOfCompanyEmployeesOnlyPerks: Scalars['Float']['output'];
  numOfGeneralPublicPerks: Scalars['Float']['output'];
  numOfLocalMemberOnlyPerks: Scalars['Float']['output'];
  numberOfMembersOfferingPerks: Scalars['Float']['output'];
  percentOfMembersOfferingPerks: Scalars['Float']['output'];
  totalActivePerks: Scalars['Float']['output'];
  totalLifeTimeCategoryAdvertisingBannersRevenueForCurrentChamber: Scalars['Float']['output'];
  totalLifeTimeRevenueFromMemberProfileAndPerksBannersForCurrentChamber: Scalars['Float']['output'];
  totalNumOfChambers: Scalars['Float']['output'];
  totalNumOfMembers: Scalars['Float']['output'];
  totalNumOfMembersPerCategoryWithActiveMemberProfileAndPerksBannersForCurrentChamber?: Maybe<Array<TotalNumOfMembersPerCategoryWithActiveMemberProfileAndPerksBannersReturn>>;
  totalNumOfMembersWithActiveMemberProfileAndPerksBannersForCurrentChamber: Scalars['Float']['output'];
  totalPerkViews: Scalars['Float']['output'];
};

export type TimeSeriesAppUserDataPointReturn = {
  __typename?: 'TimeSeriesAppUserDataPointReturn';
  monthAndYear: Scalars['String']['output'];
  numberOfAppUsers: Scalars['Float']['output'];
};

export type TimeSeriesAppUsersDataReturn = {
  __typename?: 'TimeSeriesAppUsersDataReturn';
  monthly: Array<TimeSeriesAppUserDataPointReturn>;
};

export type TimeSeriesChamberEngageDataReturn = {
  __typename?: 'TimeSeriesChamberEngageDataReturn';
  lifetimeTotal: ChamberEngageActivationFeeRevenueReturn;
  lifetimeTotalPerChamber: Array<TimeSeriesChamberEngageLifetimeTotalPerChamberDataPointReturn>;
  monthlyPerChamber: Array<TimeSeriesChamberEngageMonthlyPerChamberDataPointReturn>;
  monthlyTotal: Array<TimeSeriesChamberEngageMonthlyDataPointReturn>;
  yearlyTotal: Array<TimeSeriesChamberEngageYearlyDataPointReturn>;
  yearlyTotalPerChamber: Array<TimeSeriesChamberEngageYearlyTotalPerChamberDataPointReturn>;
};

export type TimeSeriesChamberEngageLifetimeTotalPerChamberDataPointReturn = {
  __typename?: 'TimeSeriesChamberEngageLifetimeTotalPerChamberDataPointReturn';
  chamberId: Scalars['String']['output'];
  chamberName: Scalars['String']['output'];
  lifetimeTotalActivationFeeRevenueData: ChamberEngageActivationFeeRevenueReturn;
};

export type TimeSeriesChamberEngageMonthlyDataPointReturn = {
  __typename?: 'TimeSeriesChamberEngageMonthlyDataPointReturn';
  activationFeeRevenueData: ChamberEngageActivationFeeRevenueReturn;
  monthAndYear: Scalars['String']['output'];
};

export type TimeSeriesChamberEngageMonthlyOrYearlyIndividualChamberDataPointReturn = {
  __typename?: 'TimeSeriesChamberEngageMonthlyOrYearlyIndividualChamberDataPointReturn';
  activationFeeRevenueData: ChamberEngageActivationFeeRevenueReturn;
  chamberId: Scalars['String']['output'];
  chamberName: Scalars['String']['output'];
};

export type TimeSeriesChamberEngageMonthlyPerChamberDataPointReturn = {
  __typename?: 'TimeSeriesChamberEngageMonthlyPerChamberDataPointReturn';
  chamberData: Array<TimeSeriesChamberEngageMonthlyOrYearlyIndividualChamberDataPointReturn>;
  monthAndYear: Scalars['String']['output'];
};

export type TimeSeriesChamberEngageYearlyDataPointReturn = {
  __typename?: 'TimeSeriesChamberEngageYearlyDataPointReturn';
  activationFeeRevenueData: ChamberEngageActivationFeeRevenueReturn;
  year: Scalars['String']['output'];
};

export type TimeSeriesChamberEngageYearlyTotalPerChamberDataPointReturn = {
  __typename?: 'TimeSeriesChamberEngageYearlyTotalPerChamberDataPointReturn';
  chamberData: Array<TimeSeriesChamberEngageMonthlyOrYearlyIndividualChamberDataPointReturn>;
  year: Scalars['String']['output'];
};

export type TotalNumOfMembersPerCategoryWithActiveMemberProfileAndPerksBannersReturn = {
  __typename?: 'TotalNumOfMembersPerCategoryWithActiveMemberProfileAndPerksBannersReturn';
  categoryId: Scalars['String']['output'];
  totalNumOfMembers: Scalars['Float']['output'];
};

export type UnverifiedCpaUserInfoReturn = {
  __typename?: 'UnverifiedCpaUserInfoReturn';
  email: Scalars['String']['output'];
  signUpChamber: Scalars['String']['output'];
  signUpChamberMember?: Maybe<Scalars['String']['output']>;
};

export type UpdateChamberEngageSettingsForChamberReturn = {
  __typename?: 'UpdateChamberEngageSettingsForChamberReturn';
  settingsUpdatedSuccessfully: Scalars['Boolean']['output'];
};

export type UpdateChamberMutationInput = {
  data: ChamberInput;
};

export type UpdateDiscountReturn = {
  __typename?: 'UpdateDiscountReturn';
  id: Scalars['String']['output'];
};

export type UpdateLoggedInUserLanguageMutationReturn = {
  __typename?: 'UpdateLoggedInUserLanguageMutationReturn';
  updated: Scalars['Boolean']['output'];
};

export type UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationReturn = {
  __typename?: 'UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationReturn';
  updated: Scalars['Boolean']['output'];
};

export type UpdatePerkPartnerDiscountReturn = {
  __typename?: 'UpdatePerkPartnerDiscountReturn';
  id: Scalars['String']['output'];
};

export type UpdateRewardCampaignMutationReturn = {
  __typename?: 'UpdateRewardCampaignMutationReturn';
  campaignUpdatedSuccessfully: Scalars['Boolean']['output'];
};

export type UpdateShopLocalCampaignReturn = {
  __typename?: 'UpdateShopLocalCampaignReturn';
  shopLocalCampaignUpdatedSuccessfully: Scalars['Boolean']['output'];
};

export type UpdateUserMutationReturn = {
  __typename?: 'UpdateUserMutationReturn';
  id: Scalars['String']['output'];
  updated: Scalars['Boolean']['output'];
};

export type UpsertCapUserShareRecordMutationReturn = {
  __typename?: 'UpsertCapUserShareRecordMutationReturn';
  upsertedSuccessfully: Scalars['Boolean']['output'];
};

export type UpsertRedBubbleNotificationViewReturn = {
  __typename?: 'UpsertRedBubbleNotificationViewReturn';
  redBubbleNotificationViewCreatedSuccessfully: Scalars['Boolean']['output'];
};

export type UsagePermissionReturn = {
  __typename?: 'UsagePermissionReturn';
  chamberMemberPro_EnabledPages?: Maybe<Array<ChamberMemberProPagePermissionsEnum>>;
};

export type UserInput = {
  chamberId: Scalars['String']['input'];
  chamberMemberId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  marketingEmailAccepted: Scalars['Boolean']['input'];
  nearbyPerkNotificationsActive?: InputMaybe<Scalars['Boolean']['input']>;
  newPerkNotificationsActive?: InputMaybe<Scalars['Boolean']['input']>;
  notificationToken?: InputMaybe<Scalars['String']['input']>;
};

export type UserIsEligibleBoolAndSendNotificationForEachEligibleNearbyDiscountReturn = {
  __typename?: 'UserIsEligibleBoolAndSendNotificationForEachEligibleNearbyDiscountReturn';
  discountId: Scalars['String']['output'];
  userIsEligible: Scalars['Boolean']['output'];
};

export type UserReturn = {
  __typename?: 'UserReturn';
  chamberId: Scalars['String']['output'];
  chamberInfo: ChamberReturn;
  chamberMemberId?: Maybe<Scalars['String']['output']>;
  chamberMemberInfo?: Maybe<ChamberMemberReturn>;
  createdAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  languageCode?: Maybe<LanguageCodeEnum>;
  marketingEmailAccepted: Scalars['Boolean']['output'];
  nearbyPerkNotificationsActive?: Maybe<Scalars['Boolean']['output']>;
  newPerkNotificationsActive?: Maybe<Scalars['Boolean']['output']>;
  notificationToken?: Maybe<Scalars['String']['output']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']['output']>;
  usagePermissions: UsagePermissionReturn;
};

export enum UserType {
  CapUser = 'CAP_USER',
  ChamberAdmin = 'CHAMBER_ADMIN',
  ChamberMemberAdmin = 'CHAMBER_MEMBER_ADMIN',
  PerkPartnerDiscountAdmin = 'PERK_PARTNER_DISCOUNT_ADMIN',
  RootAdmin = 'ROOT_ADMIN'
}

export type VerifyUserVerificationCodeMutationReturn = {
  __typename?: 'VerifyUserVerificationCodeMutationReturn';
  userVerificationCodeVerifiedSuccessfully: Scalars['Boolean']['output'];
};

export enum WhereToRedeemEnum {
  ContactCompany = 'CONTACT_COMPANY',
  InPerson = 'IN_PERSON',
  Online = 'ONLINE'
}

export type SetHasSignedUpForChamberMemberMutationVariables = Exact<{ [key: string]: never; }>;


export type SetHasSignedUpForChamberMemberMutation = { __typename?: 'Mutation', setHasSignedUpForChamberMember: { __typename?: 'SetHasSignedUpForChamberMemberReturn', successfullySetHasSignedUp: boolean } };

export type SubmitCmpBetaFeedbackMutationVariables = Exact<{
  feedback: Scalars['String']['input'];
  urlPath: Scalars['String']['input'];
}>;


export type SubmitCmpBetaFeedbackMutation = { __typename?: 'Mutation', submitCMPBetaFeedback: { __typename?: 'SubmitBetaFeedbackReturn', success: boolean, message: string } };

export type UpdateChamberMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ChamberInput;
}>;


export type UpdateChamberMutation = { __typename?: 'Mutation', updateChamber: { __typename?: 'ChamberReturn', id: string, name: string, website: string, supportContactEmail: string, googleMapsApi_City_ProvinceShort_CountryShort: string, supportContactName?: string | null, supportLink?: string | null, phoneNumber?: string | null, facebook?: string | null, instagram?: string | null, threads?: string | null, linkedin?: string | null, twitter?: string | null, tiktok?: string | null, youtube?: string | null, jobPostingLink?: string | null, eventsLink?: string | null, newsletterLink?: string | null, surveyLink?: string | null, advocacyWinsLink?: string | null, memberSignupLink?: string | null, sponsorLogo?: string | null, sponsorLogoLink?: string | null, logo?: string | null, numberOfMembersFromInitialSubscriptionAgreement?: number | null, description?: string | null, address: { __typename?: 'AddressReturn', streetAddress: string, city: string, province: string, postalCode: string }, directoryBanner?: Array<{ __typename?: 'BannerReturn', contentUrl: string, imageLink?: string | null, contentType: BannerContentTypeEnum, position: number }> | null, profileBanner?: Array<{ __typename?: 'BannerReturn', contentUrl: string, imageLink?: string | null, contentType: BannerContentTypeEnum, position: number }> | null } };

export type GetChamberQueryVariables = Exact<{
  chamberId: Scalars['String']['input'];
}>;


export type GetChamberQuery = { __typename?: 'Query', getChamber: { __typename?: 'ChamberReturn', id: string, name: string, description?: string | null, website: string, supportContactEmail: string, supportContactName?: string | null, supportLink?: string | null, phoneNumber?: string | null, facebook?: string | null, instagram?: string | null, threads?: string | null, linkedin?: string | null, twitter?: string | null, tiktok?: string | null, youtube?: string | null, jobPostingLink?: string | null, eventsLink?: string | null, newsletterLink?: string | null, surveyLink?: string | null, advocacyWinsLink?: string | null, memberSignupLink?: string | null, logo?: string | null, sponsorLogo?: string | null, sponsorLogoLink?: string | null, address: { __typename?: 'AddressReturn', streetAddress: string, city: string, province: string, postalCode: string }, directoryBanner?: Array<{ __typename?: 'BannerReturn', contentUrl: string, imageLink?: string | null, contentType: BannerContentTypeEnum, position: number }> | null, profileBanner?: Array<{ __typename?: 'BannerReturn', contentUrl: string, imageLink?: string | null, contentType: BannerContentTypeEnum, position: number }> | null } };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'UserReturn', id: string, email: string, chamberId: string, chamberMemberId?: string | null, marketingEmailAccepted: boolean, chamberInfo: { __typename?: 'ChamberReturn', id: string, name: string, website: string, supportContactEmail: string, googleMapsApi_City_ProvinceShort_CountryShort: string, supportContactName?: string | null, supportLink?: string | null, phoneNumber?: string | null, facebook?: string | null, instagram?: string | null, threads?: string | null, linkedin?: string | null, twitter?: string | null, tiktok?: string | null, youtube?: string | null, jobPostingLink?: string | null, eventsLink?: string | null, newsletterLink?: string | null, surveyLink?: string | null, advocacyWinsLink?: string | null, memberSignupLink?: string | null, sponsorLogo?: string | null, sponsorLogoLink?: string | null, description?: string | null, logo?: string | null, isSandbox?: boolean | null, purchasedItems?: Array<ItemsPurchasableByChamberEnum> | null, chamberMemberProWebsiteUrl?: string | null, address: { __typename?: 'AddressReturn', streetAddress: string, city: string, province: string, postalCode: string }, directoryBanner?: Array<{ __typename?: 'BannerReturn', contentUrl: string, imageLink?: string | null, contentType: BannerContentTypeEnum, position: number }> | null, profileBanner?: Array<{ __typename?: 'BannerReturn', contentUrl: string, imageLink?: string | null, contentType: BannerContentTypeEnum, position: number }> | null }, chamberMemberInfo?: { __typename?: 'ChamberMemberReturn', id: string, chamberId: string, categoryId: Array<ChamberMemberCategory>, credentialsSentAtUtcMilli?: number | null, adminConsoleContactName?: string | null, name: string, description?: string | null, website?: string | null, phoneNumber: string, contactName?: string | null, email: string, logo?: string | null, facebook?: string | null, instagram?: string | null, threads?: string | null, linkedin?: string | null, twitter?: string | null, tiktok?: string | null, youtube?: string | null, showInApp: boolean, hasSignedUp?: boolean | null, isSuspended?: boolean | null, customContacts?: Array<{ __typename?: 'CustomContactReturn', id: string, name: string, email: string, jobTitle: string, phoneNumber?: string | null }> | null, banner?: Array<{ __typename?: 'BannerReturn', contentUrl: string, imageLink?: string | null, contentType: BannerContentTypeEnum, position: number }> | null, activeMemberProfileAndPerksBannersSettings?: { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsReturn', activationInfo: { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn', startDateUtcMilli: number, chamberMemberHasAcceptedAgreement: boolean } } | null, address: { __typename?: 'AddressReturn', streetAddress: string, city: string, province: string, postalCode: string } } | null, usagePermissions: { __typename?: 'UsagePermissionReturn', chamberMemberPro_EnabledPages?: Array<ChamberMemberProPagePermissionsEnum> | null } } };


export const SetHasSignedUpForChamberMemberDocument = gql`
    mutation setHasSignedUpForChamberMember {
  setHasSignedUpForChamberMember {
    successfullySetHasSignedUp
  }
}
    `;
export type SetHasSignedUpForChamberMemberMutationFn = Apollo.MutationFunction<SetHasSignedUpForChamberMemberMutation, SetHasSignedUpForChamberMemberMutationVariables>;

/**
 * __useSetHasSignedUpForChamberMemberMutation__
 *
 * To run a mutation, you first call `useSetHasSignedUpForChamberMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHasSignedUpForChamberMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHasSignedUpForChamberMemberMutation, { data, loading, error }] = useSetHasSignedUpForChamberMemberMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetHasSignedUpForChamberMemberMutation(baseOptions?: Apollo.MutationHookOptions<SetHasSignedUpForChamberMemberMutation, SetHasSignedUpForChamberMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetHasSignedUpForChamberMemberMutation, SetHasSignedUpForChamberMemberMutationVariables>(SetHasSignedUpForChamberMemberDocument, options);
      }
export type SetHasSignedUpForChamberMemberMutationHookResult = ReturnType<typeof useSetHasSignedUpForChamberMemberMutation>;
export type SetHasSignedUpForChamberMemberMutationResult = Apollo.MutationResult<SetHasSignedUpForChamberMemberMutation>;
export type SetHasSignedUpForChamberMemberMutationOptions = Apollo.BaseMutationOptions<SetHasSignedUpForChamberMemberMutation, SetHasSignedUpForChamberMemberMutationVariables>;
export const SubmitCmpBetaFeedbackDocument = gql`
    mutation SubmitCMPBetaFeedback($feedback: String!, $urlPath: String!) {
  submitCMPBetaFeedback(feedback: $feedback, urlPath: $urlPath) {
    success
    message
  }
}
    `;
export type SubmitCmpBetaFeedbackMutationFn = Apollo.MutationFunction<SubmitCmpBetaFeedbackMutation, SubmitCmpBetaFeedbackMutationVariables>;

/**
 * __useSubmitCmpBetaFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitCmpBetaFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCmpBetaFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCmpBetaFeedbackMutation, { data, loading, error }] = useSubmitCmpBetaFeedbackMutation({
 *   variables: {
 *      feedback: // value for 'feedback'
 *      urlPath: // value for 'urlPath'
 *   },
 * });
 */
export function useSubmitCmpBetaFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCmpBetaFeedbackMutation, SubmitCmpBetaFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCmpBetaFeedbackMutation, SubmitCmpBetaFeedbackMutationVariables>(SubmitCmpBetaFeedbackDocument, options);
      }
export type SubmitCmpBetaFeedbackMutationHookResult = ReturnType<typeof useSubmitCmpBetaFeedbackMutation>;
export type SubmitCmpBetaFeedbackMutationResult = Apollo.MutationResult<SubmitCmpBetaFeedbackMutation>;
export type SubmitCmpBetaFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitCmpBetaFeedbackMutation, SubmitCmpBetaFeedbackMutationVariables>;
export const UpdateChamberDocument = gql`
    mutation updateChamber($id: String!, $input: ChamberInput!) {
  updateChamber(id: $id, input: $input) {
    id
    name
    website
    address {
      streetAddress
      city
      province
      postalCode
    }
    supportContactEmail
    googleMapsApi_City_ProvinceShort_CountryShort
    supportContactName
    supportLink
    phoneNumber
    facebook
    instagram
    threads
    linkedin
    twitter
    tiktok
    youtube
    jobPostingLink
    eventsLink
    newsletterLink
    surveyLink
    advocacyWinsLink
    memberSignupLink
    sponsorLogo
    sponsorLogoLink
    logo
    numberOfMembersFromInitialSubscriptionAgreement
    description
    directoryBanner {
      contentUrl
      imageLink
      contentType
      position
    }
    profileBanner {
      contentUrl
      imageLink
      contentType
      position
    }
  }
}
    `;
export type UpdateChamberMutationFn = Apollo.MutationFunction<UpdateChamberMutation, UpdateChamberMutationVariables>;

/**
 * __useUpdateChamberMutation__
 *
 * To run a mutation, you first call `useUpdateChamberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChamberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChamberMutation, { data, loading, error }] = useUpdateChamberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChamberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChamberMutation, UpdateChamberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChamberMutation, UpdateChamberMutationVariables>(UpdateChamberDocument, options);
      }
export type UpdateChamberMutationHookResult = ReturnType<typeof useUpdateChamberMutation>;
export type UpdateChamberMutationResult = Apollo.MutationResult<UpdateChamberMutation>;
export type UpdateChamberMutationOptions = Apollo.BaseMutationOptions<UpdateChamberMutation, UpdateChamberMutationVariables>;
export const GetChamberDocument = gql`
    query getChamber($chamberId: String!) {
  getChamber(chamberId: $chamberId) {
    id
    name
    description
    website
    address {
      streetAddress
      city
      province
      postalCode
    }
    supportContactEmail
    supportContactName
    supportLink
    phoneNumber
    facebook
    instagram
    threads
    linkedin
    twitter
    tiktok
    youtube
    jobPostingLink
    eventsLink
    newsletterLink
    surveyLink
    advocacyWinsLink
    memberSignupLink
    logo
    sponsorLogo
    sponsorLogoLink
    directoryBanner {
      contentUrl
      imageLink
      contentType
      position
    }
    profileBanner {
      contentUrl
      imageLink
      contentType
      position
    }
  }
}
    `;

/**
 * __useGetChamberQuery__
 *
 * To run a query within a React component, call `useGetChamberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChamberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChamberQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetChamberQuery(baseOptions: Apollo.QueryHookOptions<GetChamberQuery, GetChamberQueryVariables> & ({ variables: GetChamberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChamberQuery, GetChamberQueryVariables>(GetChamberDocument, options);
      }
export function useGetChamberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChamberQuery, GetChamberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChamberQuery, GetChamberQueryVariables>(GetChamberDocument, options);
        }
export function useGetChamberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChamberQuery, GetChamberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChamberQuery, GetChamberQueryVariables>(GetChamberDocument, options);
        }
export type GetChamberQueryHookResult = ReturnType<typeof useGetChamberQuery>;
export type GetChamberLazyQueryHookResult = ReturnType<typeof useGetChamberLazyQuery>;
export type GetChamberSuspenseQueryHookResult = ReturnType<typeof useGetChamberSuspenseQuery>;
export type GetChamberQueryResult = Apollo.QueryResult<GetChamberQuery, GetChamberQueryVariables>;
export const GetUserDocument = gql`
    query getUser($userId: String!) {
  getUser(userId: $userId) {
    id
    email
    chamberId
    chamberInfo {
      id
      name
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      supportContactEmail
      googleMapsApi_City_ProvinceShort_CountryShort
      supportContactName
      supportLink
      phoneNumber
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      youtube
      jobPostingLink
      eventsLink
      newsletterLink
      surveyLink
      advocacyWinsLink
      memberSignupLink
      sponsorLogo
      sponsorLogoLink
      description
      logo
      isSandbox
      directoryBanner {
        contentUrl
        imageLink
        contentType
        position
      }
      profileBanner {
        contentUrl
        imageLink
        contentType
        position
      }
      purchasedItems
      chamberMemberProWebsiteUrl
    }
    chamberMemberId
    chamberMemberInfo {
      id
      chamberId
      categoryId
      customContacts {
        id
        name
        email
        jobTitle
        phoneNumber
      }
      banner {
        contentUrl
        imageLink
        contentType
        position
      }
      activeMemberProfileAndPerksBannersSettings {
        activationInfo {
          startDateUtcMilli
          chamberMemberHasAcceptedAgreement
        }
      }
      credentialsSentAtUtcMilli
      adminConsoleContactName
      name
      description
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      phoneNumber
      contactName
      email
      logo
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      youtube
      showInApp
      hasSignedUp
      isSuspended
    }
    marketingEmailAccepted
    usagePermissions {
      chamberMemberPro_EnabledPages
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;